/* eslint-disable quotes */
/* eslint-disable import/prefer-default-export */
/* eslint-disable comma-dangle */
/* eslint-disable quote-props */

export const contentfulEntries = {
  "sys": {
    "type": "Array"
  },
  "total": 3,
  "skip": 0,
  "limit": 100,
  "items": [
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "1es0unlkw916"
          }
        },
        "id": "25fKmipa9hxRTkKyqtClel",
        "type": "Entry",
        "createdAt": "2019-10-03T12:56:05.171Z",
        "updatedAt": "2019-10-10T15:46:13.951Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 11,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "route"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "title": "Erlebnisreich",
        "locations": [
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "7J95WjmdU3FWzx0hwPOkJb",
              "type": "Entry",
              "createdAt": "2019-10-03T12:27:59.091Z",
              "updatedAt": "2019-10-03T12:27:59.091Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "location"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Bern, Höheweg",
              "location": {
                "lon": 7.461626840015811,
                "lat": 46.945792293565205
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "xTDNC3LU936C1gjVmvFXk",
              "type": "Entry",
              "createdAt": "2019-10-03T12:19:45.941Z",
              "updatedAt": "2019-10-03T12:19:45.941Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "location"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Luzern",
              "location": {
                "lon": 8.310826200000065,
                "lat": 47.0507934
              }
            }
          }
        ],
        "partRoutes": [
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5XXIacwOxmGUEiL9RSFO6f",
              "type": "Entry",
              "createdAt": "2019-10-08T08:58:54.230Z",
              "updatedAt": "2019-10-10T16:47:45.377Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 4,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r3 Bern Höheweg -Bern Bahnhof",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "6EaG2YTlZFoi9DVXE3PSZh",
                    "type": "Entry",
                    "createdAt": "2019-10-08T08:48:46.898Z",
                    "updatedAt": "2019-10-08T08:49:18.433Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Brücken",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "4EbL6vJFcER68gikHWucyV",
                        "type": "Asset",
                        "createdAt": "2019-10-08T08:45:58.643Z",
                        "updatedAt": "2019-10-08T08:45:58.643Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Brücken",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/4EbL6vJFcER68gikHWucyV/bb0e96f86d48bb1f414fec5a59f04154/alain-GIWvrROAZE0-unsplash.jpg",
                          "details": {
                            "size": 3757313,
                            "image": {
                              "width": 4000,
                              "height": 6000
                            }
                          },
                          "fileName": "alain-GIWvrROAZE0-unsplash.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Fahr zum Altenbergsteg runter und geniess den Anblick der verschiedenen Brücken die Ruhe an\nder Aare. ",
                    "location": {
                      "lon": 7.4486592000000655,
                      "lat": 46.9503949
                    },
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1nmTM1u3sYcb62YmZAq8Dr",
                        "type": "Entry",
                        "createdAt": "2019-10-04T09:46:33.431Z",
                        "updatedAt": "2019-10-04T11:46:09.278Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 2,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Aktivitaet"
                      }
                    }
                  }
                },
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "5kJney3TsnDMPMOHnb2mA1",
                    "type": "Entry",
                    "createdAt": "2019-10-08T08:47:22.318Z",
                    "updatedAt": "2019-10-08T08:47:22.318Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "cupcake",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "016GYH36BqhAVd5wZVfsfG",
                        "type": "Asset",
                        "createdAt": "2019-10-08T08:45:26.956Z",
                        "updatedAt": "2019-10-08T08:45:26.956Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "cupcakes",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/016GYH36BqhAVd5wZVfsfG/ac509e4c1cc5f30aa96f9bfd6f292b80/brian-chan-qJ0zGkrE1Zg-unsplash.jpg",
                          "details": {
                            "size": 1424621,
                            "image": {
                              "width": 4272,
                              "height": 2848
                            }
                          },
                          "fileName": "brian-chan-qJ0zGkrE1Zg-unsplash.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Hol dir zur Stärkung einen Cupcake bei Cupcake-Affair Bern. ",
                    "location": {
                      "lon": 7.43926799999997,
                      "lat": 46.9475169
                    },
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "2pJge6Pyt7hpbKhEcHunDS",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:07:48.634Z",
                        "updatedAt": "2019-10-03T12:07:48.634Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Kulinarisch"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "5L2NTl359ZHtIPvOaMHZmo",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:56:26.123Z",
                  "updatedAt": "2019-10-09T12:08:27.654Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 3,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Fahrrad",
                  "icon": "bicycle.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "7J95WjmdU3FWzx0hwPOkJb",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:27:59.091Z",
                    "updatedAt": "2019-10-03T12:27:59.091Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Bern, Höheweg",
                    "location": {
                      "lon": 7.461626840015811,
                      "lat": 46.945792293565205
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "79lgsi0p4GonIr1z8XphVX",
                  "type": "Asset",
                  "createdAt": "2019-10-10T10:52:24.466Z",
                  "updatedAt": "2019-10-10T10:52:24.466Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 1,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "map-R3 BernH Bernbahnof",
                  "description": "Velo",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/79lgsi0p4GonIr1z8XphVX/5dee0440ac5ef38c925f745be8ef2038/map-R3_BernH_Bernbahnof.geojson",
                    "details": {
                      "size": 1700
                    },
                    "fileName": "map-R3 BernH_Bernbahnof.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "6CmgoIz5BnsMtCJ6yfAhqn",
              "type": "Entry",
              "createdAt": "2019-10-08T09:03:52.605Z",
              "updatedAt": "2019-10-10T16:47:32.476Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 3,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r3 Bern Bahnhof - Interlaken Bahnhof",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "4DsgQ7cy4LS0jirpA9ZAYO",
                    "type": "Entry",
                    "createdAt": "2019-10-08T08:50:58.568Z",
                    "updatedAt": "2019-10-08T08:50:58.568Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Thun",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "H5iujXNQQGhnCKIxjq2Js",
                        "type": "Asset",
                        "createdAt": "2019-10-02T11:59:49.622Z",
                        "updatedAt": "2019-10-02T11:59:49.622Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Thun",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/H5iujXNQQGhnCKIxjq2Js/70f932f30e16ccdf5783f1c0c1e4f309/IMG_1785-HDR-WRT-Lergier.jpg",
                          "details": {
                            "size": 11642879,
                            "image": {
                              "width": 5425,
                              "height": 3617
                            }
                          },
                          "fileName": "IMG_1785-HDR-WRT-Lergier.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Entdecke die Altstadt und das Schloss in Thun.",
                    "location": {
                      "lon": 7.627988100000039,
                      "lat": 46.7579868
                    },
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1nmTM1u3sYcb62YmZAq8Dr",
                        "type": "Entry",
                        "createdAt": "2019-10-04T09:46:33.431Z",
                        "updatedAt": "2019-10-04T11:46:09.278Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 2,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Aktivitaet"
                      }
                    }
                  }
                },
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "68BiEk7i19wmAcG0je2gom",
                    "type": "Entry",
                    "createdAt": "2019-10-08T09:02:22.113Z",
                    "updatedAt": "2019-10-09T11:18:17.074Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Thunersee",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "48sDwwqaq8yzHhapdigeXx",
                        "type": "Asset",
                        "createdAt": "2019-10-08T08:44:36.667Z",
                        "updatedAt": "2019-10-08T08:44:36.667Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Thunersee",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/48sDwwqaq8yzHhapdigeXx/8bd55a0dbe170707c34594ef4649ac1e/prakarsh-saxena-k4AoLA76NRc-unsplash.jpg",
                          "details": {
                            "size": 3299553,
                            "image": {
                              "width": 5184,
                              "height": 2920
                            }
                          },
                          "fileName": "prakarsh-saxena-k4AoLA76NRc-unsplash.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Stand-up paddle auf dem Thuner oder Brienzersee",
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1nmTM1u3sYcb62YmZAq8Dr",
                        "type": "Entry",
                        "createdAt": "2019-10-04T09:46:33.431Z",
                        "updatedAt": "2019-10-04T11:46:09.278Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 2,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Aktivitaet"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "5ziMOVnwRUM5iU5cZrsxk",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:57:07.808Z",
                  "updatedAt": "2019-10-09T11:42:40.159Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Zug",
                  "icon": "train.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "4saajFL03n7IF1X7JDXboX",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:19:25.747Z",
                    "updatedAt": "2019-10-04T11:59:08.221Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Bern Bahnhof",
                    "location": {
                      "lon": 7.44041279999999,
                      "lat": 46.9476485
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "66a0prYBagbqkTccJiQ7IM",
                  "type": "Asset",
                  "createdAt": "2019-10-10T11:04:56.800Z",
                  "updatedAt": "2019-10-10T11:04:56.800Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 1,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "map-R3 Bernbahnhof Interlaken",
                  "description": "Zug",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/66a0prYBagbqkTccJiQ7IM/466813b0dc36538279b057609fbf4e73/map-R3_Bernbahnhof_Interlaken.geojson",
                    "details": {
                      "size": 3290
                    },
                    "fileName": "map-R3_Bernbahnhof_Interlaken.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "HPkYRVy1vZCcgIhcK3wrd",
              "type": "Entry",
              "createdAt": "2019-10-08T09:11:34.059Z",
              "updatedAt": "2019-10-10T16:47:03.901Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 5,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r3 Interlaken- Meiringen Hasliberg",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "4E9g9yLCZh6guB69fudAqn",
                    "type": "Entry",
                    "createdAt": "2019-10-08T09:10:41.767Z",
                    "updatedAt": "2019-10-08T09:51:28.162Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Berge",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "3mwSrRohxVlXBfmPP14nbA",
                        "type": "Asset",
                        "createdAt": "2019-10-08T09:08:49.854Z",
                        "updatedAt": "2019-10-08T09:08:49.854Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Meiringen Hasliberg",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/3mwSrRohxVlXBfmPP14nbA/57b4868c21561860d9d0cf7cc71c4926/florian-gretillat-zj_9WewVEw0-unsplash.jpg",
                          "details": {
                            "size": 2169578,
                            "image": {
                              "width": 2655,
                              "height": 3975
                            }
                          },
                          "fileName": "florian-gretillat-zj_9WewVEw0-unsplash.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Mach einen Stop in Meiringen und entdecke zu Fuss die wunderschöne Umgebung.",
                    "location": {
                      "lon": 8.190908100000001,
                      "lat": 46.7251614
                    },
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1nmTM1u3sYcb62YmZAq8Dr",
                        "type": "Entry",
                        "createdAt": "2019-10-04T09:46:33.431Z",
                        "updatedAt": "2019-10-04T11:46:09.278Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 2,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Aktivitaet"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "4cL0TjiGOhUEj8zs6eQQeJ",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:56:44.855Z",
                  "updatedAt": "2019-10-09T11:42:51.303Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Fuss",
                  "icon": "walk.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "2V2GckCdRiqU5JgPJK8qTD",
                    "type": "Entry",
                    "createdAt": "2019-10-08T09:13:14.832Z",
                    "updatedAt": "2019-10-08T09:13:19.716Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Interlaken",
                    "location": {
                      "lon": 7.863204900000028,
                      "lat": 46.6863481
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "3vM1IyJroYFjT8XxhZ71ge",
                  "type": "Asset",
                  "createdAt": "2019-10-10T11:21:05.450Z",
                  "updatedAt": "2019-10-10T11:21:05.450Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 1,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "map-R3 Interlaken Meiringen",
                  "description": "Zug, Fuss",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/3vM1IyJroYFjT8XxhZ71ge/21af68fe2d4e6b0dd49eb465c3e0b56c/map-R3_Interlaken_Meiringen.geojson",
                    "details": {
                      "size": 5421
                    },
                    "fileName": "map-R3_Interlaken_Meiringen.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5fEUtCWMCNp4Efb3ySN9Dh",
              "type": "Entry",
              "createdAt": "2019-10-08T09:55:32.172Z",
              "updatedAt": "2019-10-11T08:30:34.267Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 5,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r3 Meiringen- Luzern Bahnhof",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "4TuLPGb9cbptmjF1031XMH",
                    "type": "Entry",
                    "createdAt": "2019-10-11T08:29:18.794Z",
                    "updatedAt": "2019-10-11T08:29:18.794Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Brünigpass",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "7043J1sN0xlS2jSVtJ1Lgd",
                        "type": "Asset",
                        "createdAt": "2019-10-11T08:27:00.397Z",
                        "updatedAt": "2019-10-11T08:27:00.397Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Brünigpass",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/7043J1sN0xlS2jSVtJ1Lgd/7cf7c820b77f58f6e364b6909d57c8c6/9036620-Brienz.jpg",
                          "details": {
                            "size": 1116737,
                            "image": {
                              "width": 2454,
                              "height": 1381
                            }
                          },
                          "fileName": "9036620-Brienz.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Auf dieser Route kannst auch auf die alte Dampfbahn umsteigen.",
                    "location": {
                      "lon": 8.136790000000019,
                      "lat": 46.7565
                    },
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1nmTM1u3sYcb62YmZAq8Dr",
                        "type": "Entry",
                        "createdAt": "2019-10-04T09:46:33.431Z",
                        "updatedAt": "2019-10-04T11:46:09.278Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 2,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Aktivitaet"
                      }
                    }
                  }
                },
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "4H7SV4DZuSiXtzgIJfMbWq",
                    "type": "Entry",
                    "createdAt": "2019-10-08T09:57:08.406Z",
                    "updatedAt": "2019-10-11T09:26:49.310Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Turm",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1gOT3r97QIiGBjBx6KlwqX",
                        "type": "Asset",
                        "createdAt": "2019-10-08T09:56:06.932Z",
                        "updatedAt": "2019-10-08T09:56:06.932Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Hexenturm",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/1gOT3r97QIiGBjBx6KlwqX/24147c4039ccff423d9d0767df87dd45/images-10.jpeg",
                          "details": {
                            "size": 9063,
                            "image": {
                              "width": 275,
                              "height": 183
                            }
                          },
                          "fileName": "images-10.jpeg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Der Hexenturm von Sarnen im Kanton Obwalden in der Schweiz ist einer der wenigen noch erhaltenen Burgtürme aus der Zeit der Entstehung der Schweizerischen Eidgenossenschaft. Er wurde um 1285 erbaut und kam um 1315 in den Besitz des Landes Obwalden.",
                    "location": {
                      "lon": 8.245675799999958,
                      "lat": 46.8959313
                    },
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1elA60J5VPKasNM6VNpwJY",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:11:01.671Z",
                        "updatedAt": "2019-10-03T12:11:01.671Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Wissen"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "5ziMOVnwRUM5iU5cZrsxk",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:57:07.808Z",
                  "updatedAt": "2019-10-09T11:42:40.159Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Zug",
                  "icon": "train.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "2uxCV0AUKKtxZaW9yQcASH",
                    "type": "Entry",
                    "createdAt": "2019-10-08T09:13:49.393Z",
                    "updatedAt": "2019-10-08T09:13:49.393Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Meiringen-Hasliberg",
                    "location": {
                      "lon": 8.190908100000001,
                      "lat": 46.7251614
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "2ERiPx0iyVJ4qiArie7gzj",
                  "type": "Asset",
                  "createdAt": "2019-10-10T11:33:29.676Z",
                  "updatedAt": "2019-10-10T11:33:29.676Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 1,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "map-R3 Meiringen LuzernBahnhof",
                  "description": "Zug, Fuss",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/2ERiPx0iyVJ4qiArie7gzj/8e691aabc6270d48139ddb6b2c6d3535/map-R3__Meiringen_LuzernBahnhof.geojson",
                    "details": {
                      "size": 4370
                    },
                    "fileName": "map-R3_ Meiringen_LuzernBahnhof.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "jCqdYOgVDoQ2EqMBLIAhQ",
              "type": "Entry",
              "createdAt": "2019-10-08T09:58:29.015Z",
              "updatedAt": "2019-10-10T09:19:12.865Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r3 Luzern Bahnhof -Werkstatt",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "3PnRLWenv413BRoWJX2xbN",
                    "type": "Entry",
                    "createdAt": "2019-10-08T09:53:44.642Z",
                    "updatedAt": "2019-10-08T09:53:44.642Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Zur Werkstatt",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "4skLtIKCG13FwiEKyBH4BD",
                        "type": "Asset",
                        "createdAt": "2019-10-08T09:52:04.999Z",
                        "updatedAt": "2019-10-08T09:55:44.561Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 2,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Zur Werkstatt",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/4skLtIKCG13FwiEKyBH4BD/757b5614b4459e4d71b2cda6ddec04c3/jon-fu-1JFC1uPitUQ-unsplash.jpg",
                          "details": {
                            "size": 2014825,
                            "image": {
                              "width": 3862,
                              "height": 4827
                            }
                          },
                          "fileName": "jon-fu-1JFC1uPitUQ-unsplash.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Du hast dein Ziel erreicht. Bist Du hungrig? \nUrs hat noch einen insider Tip für Dich abseits der Touristenattraktionen.\n\nURS Tip: Restaurant zur Werkstadt",
                    "location": {
                      "lon": 8.306336699999974,
                      "lat": 47.0458113
                    },
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "2pJge6Pyt7hpbKhEcHunDS",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:07:48.634Z",
                        "updatedAt": "2019-10-03T12:07:48.634Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Kulinarisch"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "4cL0TjiGOhUEj8zs6eQQeJ",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:56:44.855Z",
                  "updatedAt": "2019-10-09T11:42:51.303Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Fuss",
                  "icon": "walk.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "xTDNC3LU936C1gjVmvFXk",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:19:45.941Z",
                    "updatedAt": "2019-10-03T12:19:45.941Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Luzern",
                    "location": {
                      "lon": 8.310826200000065,
                      "lat": 47.0507934
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "1325ZsqmHfVrLGWOXGjm7U",
                  "type": "Asset",
                  "createdAt": "2019-10-10T09:18:55.817Z",
                  "updatedAt": "2019-10-10T09:18:55.817Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 1,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "map-R3 Luzernb Werkstatt",
                  "description": "zu Fuss",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/1325ZsqmHfVrLGWOXGjm7U/c5bd2e9a2623b7814a0a247ed64bf451/map-R3_Luzernb_Werkstatt.geojson",
                    "details": {
                      "size": 585
                    },
                    "fileName": "map-R3_Luzernb_Werkstatt.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              }
            }
          }
        ],
        "id": 3,
        "routeModes": [
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5L2NTl359ZHtIPvOaMHZmo",
              "type": "Entry",
              "createdAt": "2019-10-03T09:56:26.123Z",
              "updatedAt": "2019-10-09T12:08:27.654Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 3,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Fahrrad",
              "icon": "bicycle.svg"
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5ziMOVnwRUM5iU5cZrsxk",
              "type": "Entry",
              "createdAt": "2019-10-03T09:57:07.808Z",
              "updatedAt": "2019-10-09T11:42:40.159Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Zug",
              "icon": "train.svg"
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "4cL0TjiGOhUEj8zs6eQQeJ",
              "type": "Entry",
              "createdAt": "2019-10-03T09:56:44.855Z",
              "updatedAt": "2019-10-09T11:42:51.303Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Fuss",
              "icon": "walk.svg"
            }
          }
        ],
        "duration": "2h 51min",
        "numberTips": 7,
        "mapMarker": {
          "sys": {
            "space": {
              "sys": {
                "type": "Link",
                "linkType": "Space",
                "id": "1es0unlkw916"
              }
            },
            "id": "3pl039XsQzKaszISrEwNu4",
            "type": "Asset",
            "createdAt": "2019-10-10T15:44:38.104Z",
            "updatedAt": "2019-10-10T15:44:38.104Z",
            "environment": {
              "sys": {
                "id": "master",
                "type": "Link",
                "linkType": "Environment"
              }
            },
            "revision": 1,
            "locale": "en-US"
          },
          "fields": {
            "title": "Marker violet",
            "file": {
              "url": "//images.ctfassets.net/1es0unlkw916/3pl039XsQzKaszISrEwNu4/8c3a6de3c081095a18251bbd1cd9312f/Marker_violet.svg",
              "details": {
                "size": 836,
                "image": {
                  "width": 24,
                  "height": 23
                }
              },
              "fileName": "Marker_violet.svg",
              "contentType": "image/svg+xml"
            }
          }
        }
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "1es0unlkw916"
          }
        },
        "id": "7f9il7eMe7RZItme2iv9p3",
        "type": "Entry",
        "createdAt": "2019-10-03T12:55:21.340Z",
        "updatedAt": "2019-10-10T15:47:14.428Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 15,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "route"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "title": "Schnell",
        "locations": [
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "7J95WjmdU3FWzx0hwPOkJb",
              "type": "Entry",
              "createdAt": "2019-10-03T12:27:59.091Z",
              "updatedAt": "2019-10-03T12:27:59.091Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "location"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Bern, Höheweg",
              "location": {
                "lon": 7.461626840015811,
                "lat": 46.945792293565205
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "xTDNC3LU936C1gjVmvFXk",
              "type": "Entry",
              "createdAt": "2019-10-03T12:19:45.941Z",
              "updatedAt": "2019-10-03T12:19:45.941Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "location"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Luzern",
              "location": {
                "lon": 8.310826200000065,
                "lat": 47.0507934
              }
            }
          }
        ],
        "partRoutes": [
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "bIrZabISHFYreGXJcI1HW",
              "type": "Entry",
              "createdAt": "2019-10-07T21:29:44.468Z",
              "updatedAt": "2019-10-10T19:20:19.704Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 5,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r1 bern Höheweg -bern bahnhof",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "2177PADcFjrxyR9nKpRnJI",
                    "type": "Entry",
                    "createdAt": "2019-10-07T21:36:12.561Z",
                    "updatedAt": "2019-10-07T22:11:32.596Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 5,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Aare",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "3m73fRCOLvmN1XPCSbmDPC",
                        "type": "Asset",
                        "createdAt": "2019-10-07T22:07:15.240Z",
                        "updatedAt": "2019-10-08T08:43:34.397Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 2,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Kirchfeldbrücke",
                        "description": "Kirchfeldbrücke",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/3m73fRCOLvmN1XPCSbmDPC/dbed9fd31e16920c299dd09f6f17d09b/will-truettner-aigrKLc6xc0-unsplash.jpg",
                          "details": {
                            "size": 9411132,
                            "image": {
                              "width": 4912,
                              "height": 7360
                            }
                          },
                          "fileName": "will-truettner-aigrKLc6xc0-unsplash.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Fahr über die Kirchfeldbrücke und geniess den Blick über die Aare.\nDie Kirchfeldbrücke wurde in in 21 Monaten errichtet und am 24. September 1883 eingeweiht.",
                    "location": {
                      "lon": 7.448576900000035,
                      "lat": 46.9457675
                    },
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1elA60J5VPKasNM6VNpwJY",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:11:01.671Z",
                        "updatedAt": "2019-10-03T12:11:01.671Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Wissen"
                      }
                    }
                  }
                },
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "61Xs1TfFwkh06lS4RSG3fX",
                    "type": "Entry",
                    "createdAt": "2019-10-07T21:44:03.829Z",
                    "updatedAt": "2019-10-09T10:56:21.226Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Adrianos",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1bM76eqaSDR9H1bl1UXAp6",
                        "type": "Asset",
                        "createdAt": "2019-10-04T10:14:55.880Z",
                        "updatedAt": "2019-10-04T10:14:55.880Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "dario-DLrRYHBydj4-unsplash",
                        "description": "Adrianos\n",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/1bM76eqaSDR9H1bl1UXAp6/14fb778d0c8afccad4faf5b8a62c0e1f/dario-DLrRYHBydj4-unsplash.jpg",
                          "details": {
                            "size": 2400378,
                            "image": {
                              "width": 3036,
                              "height": 4048
                            }
                          },
                          "fileName": "dario-DLrRYHBydj4-unsplash.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Hol dir einen Kaffe in der Adrianos Bar. Adrianos hat eine Hauseigene Rösterei in der Alten Feuerwehr Viktoria in Bern.",
                    "location": {
                      "lon": 7.447254199999975,
                      "lat": 46.9478491
                    },
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "2pJge6Pyt7hpbKhEcHunDS",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:07:48.634Z",
                        "updatedAt": "2019-10-03T12:07:48.634Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Kulinarisch"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "7wBJJHUf6Nvt5dShbA1wM",
                  "type": "Entry",
                  "createdAt": "2019-10-07T18:40:27.893Z",
                  "updatedAt": "2019-10-09T11:42:29.475Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Bus",
                  "icon": "bus.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "7J95WjmdU3FWzx0hwPOkJb",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:27:59.091Z",
                    "updatedAt": "2019-10-03T12:27:59.091Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Bern, Höheweg",
                    "location": {
                      "lon": 7.461626840015811,
                      "lat": 46.945792293565205
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "33gcGdVeIelynHE12vChpl",
                  "type": "Asset",
                  "createdAt": "2019-10-10T08:39:04.075Z",
                  "updatedAt": "2019-10-10T08:41:31.120Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "map-R1 BernH BernBahnhof",
                  "description": "Fuss, Buss",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/33gcGdVeIelynHE12vChpl/9ba7ace0e761a24ba65720a180c884fd/map-R1_BernH_BernBahnhof.geojson",
                    "details": {
                      "size": 1414
                    },
                    "fileName": "map-R1_BernH_BernBahnhof.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "7LCVWRlPEm8N8FlzSfH16c",
              "type": "Entry",
              "createdAt": "2019-10-03T10:49:13.634Z",
              "updatedAt": "2019-10-10T19:20:30.892Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 6,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r1 Bern - Luzern ",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "2qbII0SeGM07kSnu300jmN",
                    "type": "Entry",
                    "createdAt": "2019-10-04T11:15:13.880Z",
                    "updatedAt": "2019-10-09T11:03:09.608Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Herzogenbuchsee",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "Ffe1iaLvziHO989F4srti",
                        "type": "Asset",
                        "createdAt": "2019-10-04T11:16:00.939Z",
                        "updatedAt": "2019-10-04T11:16:00.939Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "kreuz herzogenbuchsee herzogenbuchsee 3360 herzogenbuchsee kreuz01 aussen",
                        "description": "Herzogenbuchsee",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/Ffe1iaLvziHO989F4srti/9f742b7982d0423a8897cf3daab86bee/kreuz_herzogenbuchsee_herzogenbuchsee_3360_herzogenbuchsee_kreuz01_aussen.jpg",
                          "details": {
                            "size": 4369954,
                            "image": {
                              "width": 3573,
                              "height": 2385
                            }
                          },
                          "fileName": "kreuz_herzogenbuchsee_herzogenbuchsee_3360_herzogenbuchsee_kreuz01_aussen.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Bereits vor zehntausend Jahren war die Gegend besiedelt. An verschiedenen Stellen rund um die heutige reformierte Kirche wurden Fundamente von römischen Gebäuden aus der Zeit um 200 n. Chr. gefunden.",
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1elA60J5VPKasNM6VNpwJY",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:11:01.671Z",
                        "updatedAt": "2019-10-03T12:11:01.671Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Wissen"
                      }
                    }
                  }
                },
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "4kpOwJHPe4BApkBEIwsliP",
                    "type": "Entry",
                    "createdAt": "2019-10-04T10:57:03.724Z",
                    "updatedAt": "2019-10-04T10:57:03.724Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Zofingen",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "3E3OG3GA4BLQAosOQcTsx4",
                        "type": "Asset",
                        "createdAt": "2019-10-04T10:15:26.162Z",
                        "updatedAt": "2019-10-04T10:15:26.162Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "portrait-home",
                        "description": "Zofingen",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/3E3OG3GA4BLQAosOQcTsx4/9f835a72234cbdcefaf121e0f59d343c/portrait-home.jpg",
                          "details": {
                            "size": 130144,
                            "image": {
                              "width": 1050,
                              "height": 699
                            }
                          },
                          "fileName": "portrait-home.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Entdecke die Altstadt und die Villa rustica von Zofingen mit ihrem wunderschönen Mosaikboden.",
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1nmTM1u3sYcb62YmZAq8Dr",
                        "type": "Entry",
                        "createdAt": "2019-10-04T09:46:33.431Z",
                        "updatedAt": "2019-10-04T11:46:09.278Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 2,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Aktivitaet"
                      }
                    }
                  }
                },
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "7pyx7cth7YaSo6sxCN27Rf",
                    "type": "Entry",
                    "createdAt": "2019-10-04T10:55:15.676Z",
                    "updatedAt": "2019-10-04T10:55:15.676Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Sempachersee",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "4yM5WoNgaczWkAkgtnSdFu",
                        "type": "Asset",
                        "createdAt": "2019-10-04T10:13:47.853Z",
                        "updatedAt": "2019-10-04T10:14:22.956Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 2,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "csm_blick-auf-sempachersee-herbst_1_907be51842",
                        "description": "Sepachersee\n",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/4yM5WoNgaczWkAkgtnSdFu/035eb626d3a5678657f8da1a213a053e/csm_blick-auf-sempachersee-herbst_1_907be51842.jpg",
                          "details": {
                            "size": 234969,
                            "image": {
                              "width": 1280,
                              "height": 727
                            }
                          },
                          "fileName": "csm_blick-auf-sempachersee-herbst_1_907be51842.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Sempacherschlacht war die entscheidende Schlacht im Sempacherkrieg zwischen der sich entwickelnden Eidgenossenschaft und dem Herzogtum Österreich, der von 1385 bis 1389 dauerte.",
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1elA60J5VPKasNM6VNpwJY",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:11:01.671Z",
                        "updatedAt": "2019-10-03T12:11:01.671Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Wissen"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "5ziMOVnwRUM5iU5cZrsxk",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:57:07.808Z",
                  "updatedAt": "2019-10-09T11:42:40.159Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Zug",
                  "icon": "train.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "4saajFL03n7IF1X7JDXboX",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:19:25.747Z",
                    "updatedAt": "2019-10-04T11:59:08.221Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Bern Bahnhof",
                    "location": {
                      "lon": 7.44041279999999,
                      "lat": 46.9476485
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "2DmgRgy9v6KlwP8Nu6q9E2",
                  "type": "Asset",
                  "createdAt": "2019-10-10T09:06:01.304Z",
                  "updatedAt": "2019-10-10T09:06:01.304Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 1,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "map-R1 BernBahnhof LuzernB",
                  "description": "Zug",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/2DmgRgy9v6KlwP8Nu6q9E2/b6fde7c696ff2bf465b6f5c22f322897/map-R1_BernBahnhof_LuzernB.geojson",
                    "details": {
                      "size": 4002
                    },
                    "fileName": "map-R1_BernBahnhof_LuzernB.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1Rdhas1QdMXRufwceJYPiF",
              "type": "Entry",
              "createdAt": "2019-10-08T08:56:41.730Z",
              "updatedAt": "2019-10-10T09:09:43.625Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r1 Luzern Bahnhof- Luzern Löwendenkmal",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "6pTiETdCZW0um4kl0iS0kN",
                    "type": "Entry",
                    "createdAt": "2019-10-08T08:52:30.838Z",
                    "updatedAt": "2019-10-08T08:52:30.838Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Gelateria",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "wKSVz3kp8Xnub8B3Z62CI",
                        "type": "Asset",
                        "createdAt": "2019-10-08T08:44:06.701Z",
                        "updatedAt": "2019-10-08T08:44:06.701Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Gelateria",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/wKSVz3kp8Xnub8B3Z62CI/ea791f4ad74b5b686d4130cdea3bc2d2/csm_Luzern_Listicals_Glace_IMG_7133-Bearbeitet_Typo3_c2ff9376d8.jpg",
                          "details": {
                            "size": 77583,
                            "image": {
                              "width": 1280,
                              "height": 727
                            }
                          },
                          "fileName": "csm_Luzern_Listicals_Glace_IMG_7133-Bearbeitet_Typo3_c2ff9376d8.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Du hast dein Ziel erreicht.\nUrs hat noch einen tollen Tip für Dich.\n\nURS Tip: Gelateria del Alpi",
                    "location": {
                      "lon": 8.310362899999973,
                      "lat": 47.0579679
                    },
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "2pJge6Pyt7hpbKhEcHunDS",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:07:48.634Z",
                        "updatedAt": "2019-10-03T12:07:48.634Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Kulinarisch"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "4cL0TjiGOhUEj8zs6eQQeJ",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:56:44.855Z",
                  "updatedAt": "2019-10-09T11:42:51.303Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Fuss",
                  "icon": "walk.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "xTDNC3LU936C1gjVmvFXk",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:19:45.941Z",
                    "updatedAt": "2019-10-03T12:19:45.941Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Luzern",
                    "location": {
                      "lon": 8.310826200000065,
                      "lat": 47.0507934
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "1J2EfNccGiDi7QTMcLTdXb",
                  "type": "Asset",
                  "createdAt": "2019-10-10T09:09:25.883Z",
                  "updatedAt": "2019-10-10T09:09:25.883Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 1,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "map-R1 LuzernB Luzern Löwendenkmal",
                  "description": "Fuss",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/1J2EfNccGiDi7QTMcLTdXb/fa4275fdffcaf7674ead154e37f4965d/map-R1_LuzernB_Luzern_L__wendenkmal.geojson",
                    "details": {
                      "size": 818
                    },
                    "fileName": "map-R1_LuzernB_Luzern_Löwendenkmal.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              }
            }
          }
        ],
        "id": 1,
        "routeModes": [
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "7wBJJHUf6Nvt5dShbA1wM",
              "type": "Entry",
              "createdAt": "2019-10-07T18:40:27.893Z",
              "updatedAt": "2019-10-09T11:42:29.475Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Bus",
              "icon": "bus.svg"
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5ziMOVnwRUM5iU5cZrsxk",
              "type": "Entry",
              "createdAt": "2019-10-03T09:57:07.808Z",
              "updatedAt": "2019-10-09T11:42:40.159Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Zug",
              "icon": "train.svg"
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "4cL0TjiGOhUEj8zs6eQQeJ",
              "type": "Entry",
              "createdAt": "2019-10-03T09:56:44.855Z",
              "updatedAt": "2019-10-09T11:42:51.303Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Fuss",
              "icon": "walk.svg"
            }
          }
        ],
        "duration": "1 h",
        "numberTips": 5,
        "mapMarker": {
          "sys": {
            "space": {
              "sys": {
                "type": "Link",
                "linkType": "Space",
                "id": "1es0unlkw916"
              }
            },
            "id": "5QKaYQcbvydEGqWgaVy6Se",
            "type": "Asset",
            "createdAt": "2019-10-10T15:38:40.029Z",
            "updatedAt": "2019-10-10T15:43:30.982Z",
            "environment": {
              "sys": {
                "id": "master",
                "type": "Link",
                "linkType": "Environment"
              }
            },
            "revision": 2,
            "locale": "en-US"
          },
          "fields": {
            "title": "Marker mint",
            "file": {
              "url": "//images.ctfassets.net/1es0unlkw916/5QKaYQcbvydEGqWgaVy6Se/e8d41ef74ab9bc98ff3af2d49984cbf4/Marker_mint.svg",
              "details": {
                "size": 836,
                "image": {
                  "width": 24,
                  "height": 23
                }
              },
              "fileName": "Marker_mint.svg",
              "contentType": "image/svg+xml"
            }
          }
        }
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "1es0unlkw916"
          }
        },
        "id": "6Dd5Uv3oe3ALhq96zyV2FH",
        "type": "Entry",
        "createdAt": "2019-10-03T12:34:44.333Z",
        "updatedAt": "2019-10-10T14:40:23.156Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 9,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "route"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "title": "Spannend",
        "locations": [
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "7J95WjmdU3FWzx0hwPOkJb",
              "type": "Entry",
              "createdAt": "2019-10-03T12:27:59.091Z",
              "updatedAt": "2019-10-03T12:27:59.091Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "location"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Bern, Höheweg",
              "location": {
                "lon": 7.461626840015811,
                "lat": 46.945792293565205
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "xTDNC3LU936C1gjVmvFXk",
              "type": "Entry",
              "createdAt": "2019-10-03T12:19:45.941Z",
              "updatedAt": "2019-10-03T12:19:45.941Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "location"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Luzern",
              "location": {
                "lon": 8.310826200000065,
                "lat": 47.0507934
              }
            }
          }
        ],
        "partRoutes": [
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1MPyzYQ2egiohrkODzvtIb",
              "type": "Entry",
              "createdAt": "2019-10-03T12:28:18.387Z",
              "updatedAt": "2019-10-09T14:34:55.486Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 6,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r2 Höheweg - Bern",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "6JzsjxitsiPbjtGXC2QfZL",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:26:07.076Z",
                    "updatedAt": "2019-10-08T06:40:34.359Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 4,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "MÜNSTER",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1zHnn6bNw7wCo7KtJH6nEg",
                        "type": "Asset",
                        "createdAt": "2019-10-03T12:08:59.978Z",
                        "updatedAt": "2019-10-03T12:08:59.978Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "nicolas-jossi-sXqap3 VbWI-unsplash",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/1zHnn6bNw7wCo7KtJH6nEg/fd3fe0c80f8374b0573571a056731a0f/nicolas-jossi-sXqap3_VbWI-unsplash.jpg",
                          "details": {
                            "size": 463248,
                            "image": {
                              "width": 1653,
                              "height": 2652
                            }
                          },
                          "fileName": "nicolas-jossi-sXqap3_VbWI-unsplash.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Mit einer Velofahrt durch die Berner Altstadt kannst du auf deinem Weg UNESCO Kulturerbe geniessen. Im Herzen der mittelalterlichen Stadt ist das Berner Münster, ein Hauptwerk der schweizerischen Spätgotik. Die Grundsteinlegung erfolgte 1421.",
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1elA60J5VPKasNM6VNpwJY",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:11:01.671Z",
                        "updatedAt": "2019-10-03T12:11:01.671Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Wissen"
                      }
                    }
                  }
                },
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "3rl7t7ykAsQ0h83LFtUtV9",
                    "type": "Entry",
                    "createdAt": "2019-10-04T11:26:06.645Z",
                    "updatedAt": "2019-10-10T13:12:46.534Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 6,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "MANDELBÄRLI",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "563qkH6ApetL6DRMvd5GJh",
                        "type": "Asset",
                        "createdAt": "2019-10-03T12:09:00.054Z",
                        "updatedAt": "2019-10-03T12:09:00.054Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "gang-delicious-5192364-2",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/563qkH6ApetL6DRMvd5GJh/edd38bbdcda22a47679e25789cdb7eb5/gang-delicious-5192364-2.jpg",
                          "details": {
                            "size": 130914,
                            "image": {
                              "width": 821,
                              "height": 850
                            }
                          },
                          "fileName": "gang-delicious-5192364-2.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Hol dir einen von uns ab bei der Bäckerei Glatz - uns gibts schon seid 30 Jahren.",
                    "location": {
                      "lon": 12.631125093124979,
                      "lat": 53.193073272109565
                    },
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "2pJge6Pyt7hpbKhEcHunDS",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:07:48.634Z",
                        "updatedAt": "2019-10-03T12:07:48.634Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Kulinarisch"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "5L2NTl359ZHtIPvOaMHZmo",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:56:26.123Z",
                  "updatedAt": "2019-10-09T12:08:27.654Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 3,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Fahrrad",
                  "icon": "bicycle.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "7J95WjmdU3FWzx0hwPOkJb",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:27:59.091Z",
                    "updatedAt": "2019-10-03T12:27:59.091Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Bern, Höheweg",
                    "location": {
                      "lon": 7.461626840015811,
                      "lat": 46.945792293565205
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "oo8t5jtq8K0nO9NlSkCSu",
                  "type": "Asset",
                  "createdAt": "2019-10-09T11:28:59.985Z",
                  "updatedAt": "2019-10-10T07:58:20.985Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 3,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "map-R2 BernHöhneweg BernBahnhof",
                  "description": " BernHöhneweg BernBahnhof Velo",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/oo8t5jtq8K0nO9NlSkCSu/ff25ff3d8c62b54996325888861e458b/map-R2_BernH_BernBahnhof.geojson",
                    "details": {
                      "size": 1070
                    },
                    "fileName": "map-R2_BernH_BernBahnhof.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              },
              "testroute": {
                "type": "FeatureCollection",
                "features": [
                  {
                    "type": "Feature",
                    "geometry": {
                      "type": "LineString",
                      "coordinates": [
                        [
                          7.438817024230958,
                          46.94952985143932
                        ],
                        [
                          7.442851066589356,
                          46.95521294077187
                        ],
                        [
                          7.443451881408693,
                          46.95978240991069
                        ],
                        [
                          7.447228431701662,
                          46.9632971206397
                        ],
                        [
                          7.463622093200685,
                          46.96739732466478
                        ],
                        [
                          7.476925849914552,
                          46.96376573129146
                        ],
                        [
                          7.480788230895997,
                          46.96042679082949
                        ],
                        [
                          7.482933998107911,
                          46.95169769897714
                        ],
                        [
                          7.49168872833252,
                          46.94238119151947
                        ],
                        [
                          7.509284019470216,
                          46.93200807781548
                        ],
                        [
                          7.52318859100342,
                          46.924739840686726
                        ],
                        [
                          7.536578178405763,
                          46.92544326157742
                        ],
                        [
                          7.552542686462404,
                          46.91559452856742
                        ],
                        [
                          7.565760612487794,
                          46.91512549612367
                        ],
                        [
                          7.574687004089357,
                          46.911607621939886
                        ],
                        [
                          7.5777769088745135,
                          46.88897044310819
                        ],
                        [
                          7.583270072937013,
                          46.88064037150463
                        ],
                        [
                          7.596659660339356,
                          46.87747225831619
                        ],
                        [
                          7.619318962097169,
                          46.878997669498325
                        ],
                        [
                          7.657427787780763,
                          46.89636083200725
                        ],
                        [
                          7.666697502136232,
                          46.90246006833698
                        ],
                        [
                          7.6814603805542,
                          46.89941053689905
                        ],
                        [
                          7.70446300506592,
                          46.902225495153694
                        ],
                        [
                          7.7336668968200675,
                          46.92810298832562
                        ],
                        [
                          7.734804153442383,
                          46.93321691272121
                        ],
                        [
                          7.736392021179202,
                          46.938103258161924
                        ],
                        [
                          7.743773460388184,
                          46.941707293192934
                        ],
                        [
                          7.746992111206054,
                          46.945311085627445
                        ],
                        [
                          7.7480220794677725,
                          46.94914900429062
                        ],
                        [
                          7.750747203826904,
                          46.95077490974506
                        ],
                        [
                          7.754223346710204,
                          46.95100927042239
                        ],
                        [
                          7.759137153625488,
                          46.94787461143428
                        ],
                        [
                          7.764887809753418,
                          46.94545757612362
                        ],
                        [
                          7.773427963256835,
                          46.94446143284427
                        ],
                        [
                          7.784242630004885,
                          46.93918742429312
                        ]
                      ]
                    },
                    "properties": {
                      "strokeColor": "#397C8B",
                      "stroke-width": 4,
                      "stroke-opacity": 1
                    }
                  },
                  {
                    "type": "Feature",
                    "geometry": {
                      "type": "Point",
                      "coordinates": [
                        7.784993648529053,
                        46.942168767962464
                      ]
                    },
                    "properties": {
                      "marker-size": "medium",
                      "marker-color": "#75413E",
                      "marker-symbol": ""
                    }
                  }
                ]
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5ukypyl8EWHJw6Z2ou6umL",
              "type": "Entry",
              "createdAt": "2019-10-04T11:29:48.426Z",
              "updatedAt": "2019-10-09T14:31:46.104Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 6,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r2 Bern- Langnau i. E.",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "3Zf11Lc9PIKVnQWQjRWKbP",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:11:08.242Z",
                    "updatedAt": "2019-10-03T12:17:45.013Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Emmental",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "3dlX4Gk7LiWLUzBlfWbt12",
                        "type": "Asset",
                        "createdAt": "2019-10-03T12:08:59.982Z",
                        "updatedAt": "2019-10-03T12:08:59.982Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "manuel-boxler-BbwYJ36B2aw-unsplash",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/3dlX4Gk7LiWLUzBlfWbt12/2ca683b9c7aadd689d7b702db054af1b/manuel-boxler-BbwYJ36B2aw-unsplash.jpg",
                          "details": {
                            "size": 2767493,
                            "image": {
                              "width": 5464,
                              "height": 3070
                            }
                          },
                          "fileName": "manuel-boxler-BbwYJ36B2aw-unsplash.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Deine Reise führt durch das Emmental. Urs' Tip, setze dich auf die linke Seite, dann siehst Du den Napf.",
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1elA60J5VPKasNM6VNpwJY",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:11:01.671Z",
                        "updatedAt": "2019-10-03T12:11:01.671Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Wissen"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "5ziMOVnwRUM5iU5cZrsxk",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:57:07.808Z",
                  "updatedAt": "2019-10-09T11:42:40.159Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Zug",
                  "icon": "train.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "4saajFL03n7IF1X7JDXboX",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:19:25.747Z",
                    "updatedAt": "2019-10-04T11:59:08.221Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Bern Bahnhof",
                    "location": {
                      "lon": 7.44041279999999,
                      "lat": 46.9476485
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "5q00Mod2WjBFXrYXFZ0osC",
                  "type": "Asset",
                  "createdAt": "2019-10-09T11:46:01.424Z",
                  "updatedAt": "2019-10-09T11:53:01.341Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 3,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "R2 BernBahnhof- Langnau i. E.",
                  "description": "R2 Bahn BernBahnhof- Langnau i. E.",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/5q00Mod2WjBFXrYXFZ0osC/c182af188a035a920969b8e552198440/map-R2._BernB_Langnau.geojson",
                    "details": {
                      "size": 1291
                    },
                    "fileName": "map-R2._BernB_Langnau.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              },
              "testroute": {
                "type": "FeatureCollection",
                "features": [
                  {
                    "type": "Feature",
                    "geometry": {
                      "type": "LineString",
                      "coordinates": [
                        [
                          7.438859939575194,
                          46.94950055560101
                        ],
                        [
                          7.442893981933593,
                          46.95518364804432
                        ],
                        [
                          7.44349479675293,
                          46.95975311968452
                        ],
                        [
                          7.447271347045898,
                          46.96326783233767
                        ],
                        [
                          7.463665008544922,
                          46.96736803860756
                        ],
                        [
                          7.476968765258788,
                          46.963736443245985
                        ],
                        [
                          7.4808311462402335,
                          46.960397500956084
                        ],
                        [
                          7.4829769134521475,
                          46.95166840432543
                        ],
                        [
                          7.491731643676757,
                          46.94235189176862
                        ],
                        [
                          7.509326934814452,
                          46.93197877238813
                        ],
                        [
                          7.523231506347656,
                          46.92471053128251
                        ],
                        [
                          7.536621093749999,
                          46.925413952558074
                        ],
                        [
                          7.552585601806641,
                          46.915565214159955
                        ],
                        [
                          7.56580352783203,
                          46.91509618145963
                        ],
                        [
                          7.574729919433595,
                          46.911578305351505
                        ],
                        [
                          7.57781982421875,
                          46.88894111413941
                        ],
                        [
                          7.583312988281249,
                          46.880611037981254
                        ],
                        [
                          7.596702575683594,
                          46.877442923060784
                        ],
                        [
                          7.619361877441405,
                          46.878968335076856
                        ],
                        [
                          7.657470703124999,
                          46.89633150707981
                        ],
                        [
                          7.666740417480469,
                          46.90243074674521
                        ],
                        [
                          7.6815032958984375,
                          46.89938121363944
                        ],
                        [
                          7.704505920410156,
                          46.90219617343362
                        ],
                        [
                          7.735404968261718,
                          46.927524160965085
                        ],
                        [
                          7.736434936523438,
                          46.93807395606992
                        ],
                        [
                          7.748451232910156,
                          46.94721543080955
                        ],
                        [
                          7.752571105957031,
                          46.95237147154127
                        ],
                        [
                          7.778320312499999,
                          46.941355690698636
                        ],
                        [
                          7.785873413085937,
                          46.93690185924091
                        ]
                      ]
                    },
                    "properties": {
                      "strokeColor": "red",
                      "stroke-width": 4,
                      "stroke-opacity": 1
                    }
                  }
                ]
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "7cmB82HJELQCvgfPJibV4E",
              "type": "Entry",
              "createdAt": "2019-10-04T11:40:23.080Z",
              "updatedAt": "2019-10-10T12:44:37.463Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 3,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r2 Langnau i.E.",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "2sppJNBXCpnUqWo4vUsnbw",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:12:44.709Z",
                    "updatedAt": "2019-10-04T09:48:14.266Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 3,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Chüechlihus",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "5RxlYgOahrEEEYIDoUBaBR",
                        "type": "Asset",
                        "createdAt": "2019-10-03T12:09:00.290Z",
                        "updatedAt": "2019-10-03T12:09:00.290Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "emmental-ausflugstipps-chechlihus-langnau",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/5RxlYgOahrEEEYIDoUBaBR/28ae1cf5dc3f9f66bc11dff62e08718c/emmental-ausflugstipps-chechlihus-langnau.jpg",
                          "details": {
                            "size": 401110,
                            "image": {
                              "width": 1920,
                              "height": 1281
                            }
                          },
                          "fileName": "emmental-ausflugstipps-chechlihus-langnau.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Das Chüechlihus aus dem Jahr 1526 ist das älteste, weitgehend original erhaltene Holzgebäude der Region.",
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1nmTM1u3sYcb62YmZAq8Dr",
                        "type": "Entry",
                        "createdAt": "2019-10-04T09:46:33.431Z",
                        "updatedAt": "2019-10-04T11:46:09.278Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 2,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Aktivitaet"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "4cL0TjiGOhUEj8zs6eQQeJ",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:56:44.855Z",
                  "updatedAt": "2019-10-09T11:42:51.303Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Fuss",
                  "icon": "walk.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "6PSOXGUVYmVoeQNgbOa2wH",
                    "type": "Entry",
                    "createdAt": "2019-10-04T11:32:23.561Z",
                    "updatedAt": "2019-10-04T11:42:22.151Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 3,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Langnau i. E.",
                    "location": {
                      "lon": 7.784992999999986,
                      "lat": 46.93885
                    }
                  }
                }
              ]
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "27ytTAeoV3o4fEnhnipPgI",
              "type": "Entry",
              "createdAt": "2019-10-04T11:45:44.077Z",
              "updatedAt": "2019-10-10T19:10:05.645Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 5,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r2 Langnau - Trubschachen",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "3XIff1qTgKv15njyo8IwQ6",
                    "type": "Entry",
                    "createdAt": "2019-10-10T19:08:40.915Z",
                    "updatedAt": "2019-10-10T19:28:13.392Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 4,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Trub",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "uzICxJFPsW4nGLirF9qIX",
                        "type": "Asset",
                        "createdAt": "2019-10-04T10:12:13.110Z",
                        "updatedAt": "2019-10-04T10:12:13.110Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "trub-schnstes-dorf-im-emmental",
                        "description": "Trub-Trubschachen\n",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/uzICxJFPsW4nGLirF9qIX/2b6ca56d1b1e113ecea2b128419521f6/trub-schnstes-dorf-im-emmental.jpg",
                          "details": {
                            "size": 655569,
                            "image": {
                              "width": 1920,
                              "height": 1281
                            }
                          },
                          "fileName": "trub-schnstes-dorf-im-emmental.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Geniess die Fahrt durch die hübschen Dörfer wie Trub.",
                    "location": {
                      "lon": 7.790682400000037,
                      "lat": 46.9378622
                    },
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1elA60J5VPKasNM6VNpwJY",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:11:01.671Z",
                        "updatedAt": "2019-10-03T12:11:01.671Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Wissen"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "5ziMOVnwRUM5iU5cZrsxk",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:57:07.808Z",
                  "updatedAt": "2019-10-09T11:42:40.159Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Zug",
                  "icon": "train.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "6PSOXGUVYmVoeQNgbOa2wH",
                    "type": "Entry",
                    "createdAt": "2019-10-04T11:32:23.561Z",
                    "updatedAt": "2019-10-04T11:42:22.151Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 3,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Langnau i. E.",
                    "location": {
                      "lon": 7.784992999999986,
                      "lat": 46.93885
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "OPgKCSagFCgKkfxdcRZxj",
                  "type": "Asset",
                  "createdAt": "2019-10-09T12:03:48.461Z",
                  "updatedAt": "2019-10-09T12:03:48.461Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 1,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "map-R2 Langnau Trubschachen",
                  "description": "Bahn-R2 Langnau Trubschachen",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/OPgKCSagFCgKkfxdcRZxj/66006f7d28f63f77ab5536a8f9e724cb/map-R2_Langnau_Trubschachen.geojson",
                    "details": {
                      "size": 671
                    },
                    "fileName": "map-R2_Langnau_Trubschachen.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "amw0hn0KXVZwxY4TGcFlN",
              "type": "Entry",
              "createdAt": "2019-10-03T12:17:08.795Z",
              "updatedAt": "2019-10-10T12:46:13.002Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 7,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r2 Trubschachen",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "UcoPo4U4h67wlhQIzVGHd",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:08:06.876Z",
                    "updatedAt": "2019-10-08T06:45:33.038Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Kambly-Fabrik",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "6Oy7aAQdCD8bKU5y84ymRy",
                        "type": "Asset",
                        "createdAt": "2019-10-03T12:09:00.291Z",
                        "updatedAt": "2019-10-03T12:09:00.291Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "kambly-Bretzeli-Woraus Genusstraume-entstehen",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/6Oy7aAQdCD8bKU5y84ymRy/44a5aea976b4477ee0234d48ec216185/kambly-Bretzeli-Woraus_Genusstraume-entstehen.jpg",
                          "details": {
                            "size": 85542,
                            "image": {
                              "width": 876,
                              "height": 902
                            }
                          },
                          "fileName": "kambly-Bretzeli-Woraus_Genusstraume-entstehen.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Besuche die tradionsreiche Kambly-Fabrik in Trubschachen und geniesse die weltbekannten Bretzeli.",
                    "location": {
                      "lon": 7.849606999999992,
                      "lat": 46.920368
                    },
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "2pJge6Pyt7hpbKhEcHunDS",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:07:48.634Z",
                        "updatedAt": "2019-10-03T12:07:48.634Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Kulinarisch"
                      }
                    }
                  }
                },
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "8pZ2nnOAvQZbmOfQjecvc",
                    "type": "Entry",
                    "createdAt": "2019-10-04T10:53:04.622Z",
                    "updatedAt": "2019-10-10T19:52:47.807Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 6,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Marbach",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "4bokSgKssjeRALgqcxvFT",
                        "type": "Asset",
                        "createdAt": "2019-10-10T19:46:49.021Z",
                        "updatedAt": "2019-10-10T19:46:49.021Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "wandern-entlebuch-marbachegg-kemmeriboden-bad-5-2",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/4bokSgKssjeRALgqcxvFT/f36496dbc60a5edfc6c18fc83f2f2f7e/wandern-entlebuch-marbachegg-kemmeriboden-bad-5-2.jpg",
                          "details": {
                            "size": 1078182,
                            "image": {
                              "width": 1000,
                              "height": 665
                            }
                          },
                          "fileName": "wandern-entlebuch-marbachegg-kemmeriboden-bad-5-2.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Nimm Dir eine Auszeit und entdecke die Umgebung zu Fuss oder miete Dir ein Bike.\nURS Tip: Wanderung Trubschachen-Marbach",
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1nmTM1u3sYcb62YmZAq8Dr",
                        "type": "Entry",
                        "createdAt": "2019-10-04T09:46:33.431Z",
                        "updatedAt": "2019-10-04T11:46:09.278Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 2,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Aktivitaet"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "4cL0TjiGOhUEj8zs6eQQeJ",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:56:44.855Z",
                  "updatedAt": "2019-10-09T11:42:51.303Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Fuss",
                  "icon": "walk.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "28QH3BsxVaoqFqUgtUpAE9",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:17:00.410Z",
                    "updatedAt": "2019-10-03T12:17:00.411Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Trubschachen",
                    "location": {
                      "lon": 7.846130784061415,
                      "lat": 46.92169147842277
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "7968b9ubUJK55PJ0QRe0oc",
                  "type": "Asset",
                  "createdAt": "2019-10-09T12:25:51.066Z",
                  "updatedAt": "2019-10-10T08:20:01.713Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 3,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "map-R2 Trubschachen Grosshorben_ Kambly",
                  "description": "Fuss map-R2 Trubschachen Grosshorben_Kamly",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/7968b9ubUJK55PJ0QRe0oc/0f2401d6798f8ad90b7ae5cc5f4e3c75/map-R2_Trubschachen_Grosshorb_Kambly.geojson",
                    "details": {
                      "size": 3000
                    },
                    "fileName": "map-R2_Trubschachen_Grosshorb_Kambly.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "6aH2W4je7xZg5Tw25yTrBk",
              "type": "Entry",
              "createdAt": "2019-10-04T10:25:00.193Z",
              "updatedAt": "2019-10-09T12:40:54.453Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 7,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r2 Trubschachen - Luzern",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "6yswJXF4UgCVWDdwkIGMlE",
                    "type": "Entry",
                    "createdAt": "2019-10-04T10:43:42.447Z",
                    "updatedAt": "2019-10-04T10:50:12.817Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Änzilochgeist",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "5Ig7KvBKBY5O8MSwR0c3yw",
                        "type": "Asset",
                        "createdAt": "2019-10-03T12:09:00.127Z",
                        "updatedAt": "2019-10-03T12:09:00.127Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "csm 01 AEnziloch 01 Typo3 698cb5cacc",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/5Ig7KvBKBY5O8MSwR0c3yw/7f0ce3680c5bf790f4d6421fb306a866/csm_01_AEnziloch_01_Typo3_698cb5cacc.jpg",
                          "details": {
                            "size": 241259,
                            "image": {
                              "width": 1280,
                              "height": 727
                            }
                          },
                          "fileName": "csm_01_AEnziloch_01_Typo3_698cb5cacc.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Du hast das Entlebuch erreicht, wo es  unzählige Sagen gibt.\nHör Dir auf der Zugfahrt die Sage vom Änzilochgeist an. ",
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "1elA60J5VPKasNM6VNpwJY",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:11:01.671Z",
                        "updatedAt": "2019-10-03T12:11:01.671Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Wissen"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "5ziMOVnwRUM5iU5cZrsxk",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:57:07.808Z",
                  "updatedAt": "2019-10-09T11:42:40.159Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Zug",
                  "icon": "train.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "28QH3BsxVaoqFqUgtUpAE9",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:17:00.410Z",
                    "updatedAt": "2019-10-03T12:17:00.411Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Trubschachen",
                    "location": {
                      "lon": 7.846130784061415,
                      "lat": 46.92169147842277
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "30hHywqltv5XhCokIhn5HC",
                  "type": "Asset",
                  "createdAt": "2019-10-09T12:40:28.571Z",
                  "updatedAt": "2019-10-09T12:40:28.571Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 1,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "map-R2 Trubschachen Luzern",
                  "description": "Zug map-R2 Trubschachen Luzern",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/30hHywqltv5XhCokIhn5HC/04b2e9a80f09e8e9f38139971e048636/map-R2_Trubschachen_Luzern.geojson",
                    "details": {
                      "size": 3379
                    },
                    "fileName": "map-R2_Trubschachen_Luzern.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              }
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5atGSZfFOc8wM3C3yKO2Zm",
              "type": "Entry",
              "createdAt": "2019-10-07T18:29:05.581Z",
              "updatedAt": "2019-10-10T08:28:37.030Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 3,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "partRoute"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "r2 Luzern Bahnhof- Luzern St.Karliquai",
              "items": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "5j1TNJXNUud1o3yZfjrmLP",
                    "type": "Entry",
                    "createdAt": "2019-10-04T10:41:32.814Z",
                    "updatedAt": "2019-10-04T10:41:32.814Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attraction"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Karls Kraut",
                    "attractionImage": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "5F29eu8dZ1jpAYOlQXx8Ej",
                        "type": "Asset",
                        "createdAt": "2019-10-03T12:09:00.317Z",
                        "updatedAt": "2019-10-03T12:09:00.317Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "jovana-askrabic-vEBsRMCis-c-unsplash",
                        "file": {
                          "url": "//images.ctfassets.net/1es0unlkw916/5F29eu8dZ1jpAYOlQXx8Ej/ad82f0380ff9a2745cfef2e2e9039066/jovana-askrabic-vEBsRMCis-c-unsplash.jpg",
                          "details": {
                            "size": 2182061,
                            "image": {
                              "width": 4534,
                              "height": 3023
                            }
                          },
                          "fileName": "jovana-askrabic-vEBsRMCis-c-unsplash.jpg",
                          "contentType": "image/jpeg"
                        }
                      }
                    },
                    "description": "Du hast dein Ziel erreicht. Bist Du hungrig? Urs\nhat noch einen tollen Tip für Dich.\nURS Tip: Restaurante Karls Kraut",
                    "attractionType": {
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "1es0unlkw916"
                          }
                        },
                        "id": "2pJge6Pyt7hpbKhEcHunDS",
                        "type": "Entry",
                        "createdAt": "2019-10-03T12:07:48.634Z",
                        "updatedAt": "2019-10-03T12:07:48.634Z",
                        "environment": {
                          "sys": {
                            "id": "master",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "attractionType"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Kulinarisch"
                      }
                    }
                  }
                }
              ],
              "routeMode": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "4cL0TjiGOhUEj8zs6eQQeJ",
                  "type": "Entry",
                  "createdAt": "2019-10-03T09:56:44.855Z",
                  "updatedAt": "2019-10-09T11:42:51.303Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 2,
                  "contentType": {
                    "sys": {
                      "type": "Link",
                      "linkType": "ContentType",
                      "id": "routeMode"
                    }
                  },
                  "locale": "en-US"
                },
                "fields": {
                  "title": "Fuss",
                  "icon": "walk.svg"
                }
              },
              "locations": [
                {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "xTDNC3LU936C1gjVmvFXk",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:19:45.941Z",
                    "updatedAt": "2019-10-03T12:19:45.941Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "location"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Luzern",
                    "location": {
                      "lon": 8.310826200000065,
                      "lat": 47.0507934
                    }
                  }
                }
              ],
              "mapRoute": {
                "sys": {
                  "space": {
                    "sys": {
                      "type": "Link",
                      "linkType": "Space",
                      "id": "1es0unlkw916"
                    }
                  },
                  "id": "1uu4eZblrkiJuGeKcGnotY",
                  "type": "Asset",
                  "createdAt": "2019-10-10T08:28:09.513Z",
                  "updatedAt": "2019-10-10T08:28:09.513Z",
                  "environment": {
                    "sys": {
                      "id": "master",
                      "type": "Link",
                      "linkType": "Environment"
                    }
                  },
                  "revision": 1,
                  "locale": "en-US"
                },
                "fields": {
                  "title": "map-R2 LuzernBahnhof Luzern Karli",
                  "description": "zu Fuss",
                  "file": {
                    "url": "//assets.ctfassets.net/1es0unlkw916/1uu4eZblrkiJuGeKcGnotY/ed4abd075d309ee5081b2b2d7ce5ae90/map-R2_LuzernBahnhof_Luzern_Karli.geojson",
                    "details": {
                      "size": 1047
                    },
                    "fileName": "map-R2_LuzernBahnhof_Luzern_Karli.geojson",
                    "contentType": "application/octet-stream"
                  }
                }
              }
            }
          }
        ],
        "id": 2,
        "routeModes": [
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5L2NTl359ZHtIPvOaMHZmo",
              "type": "Entry",
              "createdAt": "2019-10-03T09:56:26.123Z",
              "updatedAt": "2019-10-09T12:08:27.654Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 3,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Fahrrad",
              "icon": "bicycle.svg"
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5ziMOVnwRUM5iU5cZrsxk",
              "type": "Entry",
              "createdAt": "2019-10-03T09:57:07.808Z",
              "updatedAt": "2019-10-09T11:42:40.159Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Zug",
              "icon": "train.svg"
            }
          },
          {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "4cL0TjiGOhUEj8zs6eQQeJ",
              "type": "Entry",
              "createdAt": "2019-10-03T09:56:44.855Z",
              "updatedAt": "2019-10-09T11:42:51.303Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Fuss",
              "icon": "walk.svg"
            }
          }
        ],
        "duration": "1h 29min",
        "numberTips": 7,
        "mapMarker": {
          "sys": {
            "space": {
              "sys": {
                "type": "Link",
                "linkType": "Space",
                "id": "1es0unlkw916"
              }
            },
            "id": "6QALBCBvSf44Pcmml6riMg",
            "type": "Asset",
            "createdAt": "2019-10-10T14:15:27.675Z",
            "updatedAt": "2019-10-10T14:15:27.675Z",
            "environment": {
              "sys": {
                "id": "master",
                "type": "Link",
                "linkType": "Environment"
              }
            },
            "revision": 1,
            "locale": "en-US"
          },
          "fields": {
            "title": "marker_orange",
            "file": {
              "url": "//images.ctfassets.net/1es0unlkw916/6QALBCBvSf44Pcmml6riMg/9af2533c8a023969e8269d1a5d600f18/Marker_orange.svg",
              "details": {
                "size": 946432,
                "image": {
                  "width": 24,
                  "height": 23
                }
              },
              "fileName": "Marker_orange.svg",
              "contentType": "image/svg+xml"
            }
          }
        }
      }
    }
  ],
  "includes": {
    "Entry": [
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "1MPyzYQ2egiohrkODzvtIb",
          "type": "Entry",
          "createdAt": "2019-10-03T12:28:18.387Z",
          "updatedAt": "2019-10-09T14:34:55.486Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 6,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r2 Höheweg - Bern",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "6JzsjxitsiPbjtGXC2QfZL",
                "type": "Entry",
                "createdAt": "2019-10-03T12:26:07.076Z",
                "updatedAt": "2019-10-08T06:40:34.359Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 4,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "MÜNSTER",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1zHnn6bNw7wCo7KtJH6nEg",
                    "type": "Asset",
                    "createdAt": "2019-10-03T12:08:59.978Z",
                    "updatedAt": "2019-10-03T12:08:59.978Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "nicolas-jossi-sXqap3 VbWI-unsplash",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/1zHnn6bNw7wCo7KtJH6nEg/fd3fe0c80f8374b0573571a056731a0f/nicolas-jossi-sXqap3_VbWI-unsplash.jpg",
                      "details": {
                        "size": 463248,
                        "image": {
                          "width": 1653,
                          "height": 2652
                        }
                      },
                      "fileName": "nicolas-jossi-sXqap3_VbWI-unsplash.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Mit einer Velofahrt durch die Berner Altstadt kannst du auf deinem Weg UNESCO Kulturerbe geniessen. Im Herzen der mittelalterlichen Stadt ist das Berner Münster, ein Hauptwerk der schweizerischen Spätgotik. Die Grundsteinlegung erfolgte 1421.",
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1elA60J5VPKasNM6VNpwJY",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:11:01.671Z",
                    "updatedAt": "2019-10-03T12:11:01.671Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Wissen"
                  }
                }
              }
            },
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "3rl7t7ykAsQ0h83LFtUtV9",
                "type": "Entry",
                "createdAt": "2019-10-04T11:26:06.645Z",
                "updatedAt": "2019-10-10T13:12:46.534Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 6,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "MANDELBÄRLI",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "563qkH6ApetL6DRMvd5GJh",
                    "type": "Asset",
                    "createdAt": "2019-10-03T12:09:00.054Z",
                    "updatedAt": "2019-10-03T12:09:00.054Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "gang-delicious-5192364-2",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/563qkH6ApetL6DRMvd5GJh/edd38bbdcda22a47679e25789cdb7eb5/gang-delicious-5192364-2.jpg",
                      "details": {
                        "size": 130914,
                        "image": {
                          "width": 821,
                          "height": 850
                        }
                      },
                      "fileName": "gang-delicious-5192364-2.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Hol dir einen von uns ab bei der Bäckerei Glatz - uns gibts schon seid 30 Jahren.",
                "location": {
                  "lon": 12.631125093124979,
                  "lat": 53.193073272109565
                },
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "2pJge6Pyt7hpbKhEcHunDS",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:07:48.634Z",
                    "updatedAt": "2019-10-03T12:07:48.634Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Kulinarisch"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5L2NTl359ZHtIPvOaMHZmo",
              "type": "Entry",
              "createdAt": "2019-10-03T09:56:26.123Z",
              "updatedAt": "2019-10-09T12:08:27.654Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 3,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Fahrrad",
              "icon": "bicycle.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "7J95WjmdU3FWzx0hwPOkJb",
                "type": "Entry",
                "createdAt": "2019-10-03T12:27:59.091Z",
                "updatedAt": "2019-10-03T12:27:59.091Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Bern, Höheweg",
                "location": {
                  "lon": 7.461626840015811,
                  "lat": 46.945792293565205
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "oo8t5jtq8K0nO9NlSkCSu",
              "type": "Asset",
              "createdAt": "2019-10-09T11:28:59.985Z",
              "updatedAt": "2019-10-10T07:58:20.985Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 3,
              "locale": "en-US"
            },
            "fields": {
              "title": "map-R2 BernHöhneweg BernBahnhof",
              "description": " BernHöhneweg BernBahnhof Velo",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/oo8t5jtq8K0nO9NlSkCSu/ff25ff3d8c62b54996325888861e458b/map-R2_BernH_BernBahnhof.geojson",
                "details": {
                  "size": 1070
                },
                "fileName": "map-R2_BernH_BernBahnhof.geojson",
                "contentType": "application/octet-stream"
              }
            }
          },
          "testroute": {
            "type": "FeatureCollection",
            "features": [
              {
                "type": "Feature",
                "geometry": {
                  "type": "LineString",
                  "coordinates": [
                    [
                      7.438817024230958,
                      46.94952985143932
                    ],
                    [
                      7.442851066589356,
                      46.95521294077187
                    ],
                    [
                      7.443451881408693,
                      46.95978240991069
                    ],
                    [
                      7.447228431701662,
                      46.9632971206397
                    ],
                    [
                      7.463622093200685,
                      46.96739732466478
                    ],
                    [
                      7.476925849914552,
                      46.96376573129146
                    ],
                    [
                      7.480788230895997,
                      46.96042679082949
                    ],
                    [
                      7.482933998107911,
                      46.95169769897714
                    ],
                    [
                      7.49168872833252,
                      46.94238119151947
                    ],
                    [
                      7.509284019470216,
                      46.93200807781548
                    ],
                    [
                      7.52318859100342,
                      46.924739840686726
                    ],
                    [
                      7.536578178405763,
                      46.92544326157742
                    ],
                    [
                      7.552542686462404,
                      46.91559452856742
                    ],
                    [
                      7.565760612487794,
                      46.91512549612367
                    ],
                    [
                      7.574687004089357,
                      46.911607621939886
                    ],
                    [
                      7.5777769088745135,
                      46.88897044310819
                    ],
                    [
                      7.583270072937013,
                      46.88064037150463
                    ],
                    [
                      7.596659660339356,
                      46.87747225831619
                    ],
                    [
                      7.619318962097169,
                      46.878997669498325
                    ],
                    [
                      7.657427787780763,
                      46.89636083200725
                    ],
                    [
                      7.666697502136232,
                      46.90246006833698
                    ],
                    [
                      7.6814603805542,
                      46.89941053689905
                    ],
                    [
                      7.70446300506592,
                      46.902225495153694
                    ],
                    [
                      7.7336668968200675,
                      46.92810298832562
                    ],
                    [
                      7.734804153442383,
                      46.93321691272121
                    ],
                    [
                      7.736392021179202,
                      46.938103258161924
                    ],
                    [
                      7.743773460388184,
                      46.941707293192934
                    ],
                    [
                      7.746992111206054,
                      46.945311085627445
                    ],
                    [
                      7.7480220794677725,
                      46.94914900429062
                    ],
                    [
                      7.750747203826904,
                      46.95077490974506
                    ],
                    [
                      7.754223346710204,
                      46.95100927042239
                    ],
                    [
                      7.759137153625488,
                      46.94787461143428
                    ],
                    [
                      7.764887809753418,
                      46.94545757612362
                    ],
                    [
                      7.773427963256835,
                      46.94446143284427
                    ],
                    [
                      7.784242630004885,
                      46.93918742429312
                    ]
                  ]
                },
                "properties": {
                  "strokeColor": "#397C8B",
                  "stroke-width": 4,
                  "stroke-opacity": 1
                }
              },
              {
                "type": "Feature",
                "geometry": {
                  "type": "Point",
                  "coordinates": [
                    7.784993648529053,
                    46.942168767962464
                  ]
                },
                "properties": {
                  "marker-size": "medium",
                  "marker-color": "#75413E",
                  "marker-symbol": ""
                }
              }
            ]
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "1Rdhas1QdMXRufwceJYPiF",
          "type": "Entry",
          "createdAt": "2019-10-08T08:56:41.730Z",
          "updatedAt": "2019-10-10T09:09:43.625Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r1 Luzern Bahnhof- Luzern Löwendenkmal",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "6pTiETdCZW0um4kl0iS0kN",
                "type": "Entry",
                "createdAt": "2019-10-08T08:52:30.838Z",
                "updatedAt": "2019-10-08T08:52:30.838Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Gelateria",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "wKSVz3kp8Xnub8B3Z62CI",
                    "type": "Asset",
                    "createdAt": "2019-10-08T08:44:06.701Z",
                    "updatedAt": "2019-10-08T08:44:06.701Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Gelateria",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/wKSVz3kp8Xnub8B3Z62CI/ea791f4ad74b5b686d4130cdea3bc2d2/csm_Luzern_Listicals_Glace_IMG_7133-Bearbeitet_Typo3_c2ff9376d8.jpg",
                      "details": {
                        "size": 77583,
                        "image": {
                          "width": 1280,
                          "height": 727
                        }
                      },
                      "fileName": "csm_Luzern_Listicals_Glace_IMG_7133-Bearbeitet_Typo3_c2ff9376d8.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Du hast dein Ziel erreicht.\nUrs hat noch einen tollen Tip für Dich.\n\nURS Tip: Gelateria del Alpi",
                "location": {
                  "lon": 8.310362899999973,
                  "lat": 47.0579679
                },
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "2pJge6Pyt7hpbKhEcHunDS",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:07:48.634Z",
                    "updatedAt": "2019-10-03T12:07:48.634Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Kulinarisch"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "4cL0TjiGOhUEj8zs6eQQeJ",
              "type": "Entry",
              "createdAt": "2019-10-03T09:56:44.855Z",
              "updatedAt": "2019-10-09T11:42:51.303Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Fuss",
              "icon": "walk.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "xTDNC3LU936C1gjVmvFXk",
                "type": "Entry",
                "createdAt": "2019-10-03T12:19:45.941Z",
                "updatedAt": "2019-10-03T12:19:45.941Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Luzern",
                "location": {
                  "lon": 8.310826200000065,
                  "lat": 47.0507934
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1J2EfNccGiDi7QTMcLTdXb",
              "type": "Asset",
              "createdAt": "2019-10-10T09:09:25.883Z",
              "updatedAt": "2019-10-10T09:09:25.883Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "map-R1 LuzernB Luzern Löwendenkmal",
              "description": "Fuss",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/1J2EfNccGiDi7QTMcLTdXb/fa4275fdffcaf7674ead154e37f4965d/map-R1_LuzernB_Luzern_L__wendenkmal.geojson",
                "details": {
                  "size": 818
                },
                "fileName": "map-R1_LuzernB_Luzern_Löwendenkmal.geojson",
                "contentType": "application/octet-stream"
              }
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "1elA60J5VPKasNM6VNpwJY",
          "type": "Entry",
          "createdAt": "2019-10-03T12:11:01.671Z",
          "updatedAt": "2019-10-03T12:11:01.671Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attractionType"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Wissen"
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "1nmTM1u3sYcb62YmZAq8Dr",
          "type": "Entry",
          "createdAt": "2019-10-04T09:46:33.431Z",
          "updatedAt": "2019-10-04T11:46:09.278Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attractionType"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Aktivitaet"
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "2177PADcFjrxyR9nKpRnJI",
          "type": "Entry",
          "createdAt": "2019-10-07T21:36:12.561Z",
          "updatedAt": "2019-10-07T22:11:32.596Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 5,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Aare",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "3m73fRCOLvmN1XPCSbmDPC",
              "type": "Asset",
              "createdAt": "2019-10-07T22:07:15.240Z",
              "updatedAt": "2019-10-08T08:43:34.397Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "locale": "en-US"
            },
            "fields": {
              "title": "Kirchfeldbrücke",
              "description": "Kirchfeldbrücke",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/3m73fRCOLvmN1XPCSbmDPC/dbed9fd31e16920c299dd09f6f17d09b/will-truettner-aigrKLc6xc0-unsplash.jpg",
                "details": {
                  "size": 9411132,
                  "image": {
                    "width": 4912,
                    "height": 7360
                  }
                },
                "fileName": "will-truettner-aigrKLc6xc0-unsplash.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Fahr über die Kirchfeldbrücke und geniess den Blick über die Aare.\nDie Kirchfeldbrücke wurde in in 21 Monaten errichtet und am 24. September 1883 eingeweiht.",
          "location": {
            "lon": 7.448576900000035,
            "lat": 46.9457675
          },
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1elA60J5VPKasNM6VNpwJY",
              "type": "Entry",
              "createdAt": "2019-10-03T12:11:01.671Z",
              "updatedAt": "2019-10-03T12:11:01.671Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Wissen"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "27ytTAeoV3o4fEnhnipPgI",
          "type": "Entry",
          "createdAt": "2019-10-04T11:45:44.077Z",
          "updatedAt": "2019-10-10T19:10:05.645Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 5,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r2 Langnau - Trubschachen",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "3XIff1qTgKv15njyo8IwQ6",
                "type": "Entry",
                "createdAt": "2019-10-10T19:08:40.915Z",
                "updatedAt": "2019-10-10T19:28:13.392Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 4,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Trub",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "uzICxJFPsW4nGLirF9qIX",
                    "type": "Asset",
                    "createdAt": "2019-10-04T10:12:13.110Z",
                    "updatedAt": "2019-10-04T10:12:13.110Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "trub-schnstes-dorf-im-emmental",
                    "description": "Trub-Trubschachen\n",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/uzICxJFPsW4nGLirF9qIX/2b6ca56d1b1e113ecea2b128419521f6/trub-schnstes-dorf-im-emmental.jpg",
                      "details": {
                        "size": 655569,
                        "image": {
                          "width": 1920,
                          "height": 1281
                        }
                      },
                      "fileName": "trub-schnstes-dorf-im-emmental.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Geniess die Fahrt durch die hübschen Dörfer wie Trub.",
                "location": {
                  "lon": 7.790682400000037,
                  "lat": 46.9378622
                },
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1elA60J5VPKasNM6VNpwJY",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:11:01.671Z",
                    "updatedAt": "2019-10-03T12:11:01.671Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Wissen"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5ziMOVnwRUM5iU5cZrsxk",
              "type": "Entry",
              "createdAt": "2019-10-03T09:57:07.808Z",
              "updatedAt": "2019-10-09T11:42:40.159Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Zug",
              "icon": "train.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "6PSOXGUVYmVoeQNgbOa2wH",
                "type": "Entry",
                "createdAt": "2019-10-04T11:32:23.561Z",
                "updatedAt": "2019-10-04T11:42:22.151Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 3,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Langnau i. E.",
                "location": {
                  "lon": 7.784992999999986,
                  "lat": 46.93885
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "OPgKCSagFCgKkfxdcRZxj",
              "type": "Asset",
              "createdAt": "2019-10-09T12:03:48.461Z",
              "updatedAt": "2019-10-09T12:03:48.461Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "map-R2 Langnau Trubschachen",
              "description": "Bahn-R2 Langnau Trubschachen",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/OPgKCSagFCgKkfxdcRZxj/66006f7d28f63f77ab5536a8f9e724cb/map-R2_Langnau_Trubschachen.geojson",
                "details": {
                  "size": 671
                },
                "fileName": "map-R2_Langnau_Trubschachen.geojson",
                "contentType": "application/octet-stream"
              }
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "28QH3BsxVaoqFqUgtUpAE9",
          "type": "Entry",
          "createdAt": "2019-10-03T12:17:00.410Z",
          "updatedAt": "2019-10-03T12:17:00.411Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "location"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Trubschachen",
          "location": {
            "lon": 7.846130784061415,
            "lat": 46.92169147842277
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "2V2GckCdRiqU5JgPJK8qTD",
          "type": "Entry",
          "createdAt": "2019-10-08T09:13:14.832Z",
          "updatedAt": "2019-10-08T09:13:19.716Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "location"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Interlaken",
          "location": {
            "lon": 7.863204900000028,
            "lat": 46.6863481
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "2pJge6Pyt7hpbKhEcHunDS",
          "type": "Entry",
          "createdAt": "2019-10-03T12:07:48.634Z",
          "updatedAt": "2019-10-03T12:07:48.634Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attractionType"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Kulinarisch"
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "2qbII0SeGM07kSnu300jmN",
          "type": "Entry",
          "createdAt": "2019-10-04T11:15:13.880Z",
          "updatedAt": "2019-10-09T11:03:09.608Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Herzogenbuchsee",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "Ffe1iaLvziHO989F4srti",
              "type": "Asset",
              "createdAt": "2019-10-04T11:16:00.939Z",
              "updatedAt": "2019-10-04T11:16:00.939Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "kreuz herzogenbuchsee herzogenbuchsee 3360 herzogenbuchsee kreuz01 aussen",
              "description": "Herzogenbuchsee",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/Ffe1iaLvziHO989F4srti/9f742b7982d0423a8897cf3daab86bee/kreuz_herzogenbuchsee_herzogenbuchsee_3360_herzogenbuchsee_kreuz01_aussen.jpg",
                "details": {
                  "size": 4369954,
                  "image": {
                    "width": 3573,
                    "height": 2385
                  }
                },
                "fileName": "kreuz_herzogenbuchsee_herzogenbuchsee_3360_herzogenbuchsee_kreuz01_aussen.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Bereits vor zehntausend Jahren war die Gegend besiedelt. An verschiedenen Stellen rund um die heutige reformierte Kirche wurden Fundamente von römischen Gebäuden aus der Zeit um 200 n. Chr. gefunden.",
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1elA60J5VPKasNM6VNpwJY",
              "type": "Entry",
              "createdAt": "2019-10-03T12:11:01.671Z",
              "updatedAt": "2019-10-03T12:11:01.671Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Wissen"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "2sppJNBXCpnUqWo4vUsnbw",
          "type": "Entry",
          "createdAt": "2019-10-03T12:12:44.709Z",
          "updatedAt": "2019-10-04T09:48:14.266Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 3,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Chüechlihus",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5RxlYgOahrEEEYIDoUBaBR",
              "type": "Asset",
              "createdAt": "2019-10-03T12:09:00.290Z",
              "updatedAt": "2019-10-03T12:09:00.290Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "emmental-ausflugstipps-chechlihus-langnau",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/5RxlYgOahrEEEYIDoUBaBR/28ae1cf5dc3f9f66bc11dff62e08718c/emmental-ausflugstipps-chechlihus-langnau.jpg",
                "details": {
                  "size": 401110,
                  "image": {
                    "width": 1920,
                    "height": 1281
                  }
                },
                "fileName": "emmental-ausflugstipps-chechlihus-langnau.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Das Chüechlihus aus dem Jahr 1526 ist das älteste, weitgehend original erhaltene Holzgebäude der Region.",
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1nmTM1u3sYcb62YmZAq8Dr",
              "type": "Entry",
              "createdAt": "2019-10-04T09:46:33.431Z",
              "updatedAt": "2019-10-04T11:46:09.278Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Aktivitaet"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "2uxCV0AUKKtxZaW9yQcASH",
          "type": "Entry",
          "createdAt": "2019-10-08T09:13:49.393Z",
          "updatedAt": "2019-10-08T09:13:49.393Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "location"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Meiringen-Hasliberg",
          "location": {
            "lon": 8.190908100000001,
            "lat": 46.7251614
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "3PnRLWenv413BRoWJX2xbN",
          "type": "Entry",
          "createdAt": "2019-10-08T09:53:44.642Z",
          "updatedAt": "2019-10-08T09:53:44.642Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Zur Werkstatt",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "4skLtIKCG13FwiEKyBH4BD",
              "type": "Asset",
              "createdAt": "2019-10-08T09:52:04.999Z",
              "updatedAt": "2019-10-08T09:55:44.561Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "locale": "en-US"
            },
            "fields": {
              "title": "Zur Werkstatt",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/4skLtIKCG13FwiEKyBH4BD/757b5614b4459e4d71b2cda6ddec04c3/jon-fu-1JFC1uPitUQ-unsplash.jpg",
                "details": {
                  "size": 2014825,
                  "image": {
                    "width": 3862,
                    "height": 4827
                  }
                },
                "fileName": "jon-fu-1JFC1uPitUQ-unsplash.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Du hast dein Ziel erreicht. Bist Du hungrig? \nUrs hat noch einen insider Tip für Dich abseits der Touristenattraktionen.\n\nURS Tip: Restaurant zur Werkstadt",
          "location": {
            "lon": 8.306336699999974,
            "lat": 47.0458113
          },
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "2pJge6Pyt7hpbKhEcHunDS",
              "type": "Entry",
              "createdAt": "2019-10-03T12:07:48.634Z",
              "updatedAt": "2019-10-03T12:07:48.634Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Kulinarisch"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "3XIff1qTgKv15njyo8IwQ6",
          "type": "Entry",
          "createdAt": "2019-10-10T19:08:40.915Z",
          "updatedAt": "2019-10-10T19:28:13.392Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 4,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Trub",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "uzICxJFPsW4nGLirF9qIX",
              "type": "Asset",
              "createdAt": "2019-10-04T10:12:13.110Z",
              "updatedAt": "2019-10-04T10:12:13.110Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "trub-schnstes-dorf-im-emmental",
              "description": "Trub-Trubschachen\n",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/uzICxJFPsW4nGLirF9qIX/2b6ca56d1b1e113ecea2b128419521f6/trub-schnstes-dorf-im-emmental.jpg",
                "details": {
                  "size": 655569,
                  "image": {
                    "width": 1920,
                    "height": 1281
                  }
                },
                "fileName": "trub-schnstes-dorf-im-emmental.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Geniess die Fahrt durch die hübschen Dörfer wie Trub.",
          "location": {
            "lon": 7.790682400000037,
            "lat": 46.9378622
          },
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1elA60J5VPKasNM6VNpwJY",
              "type": "Entry",
              "createdAt": "2019-10-03T12:11:01.671Z",
              "updatedAt": "2019-10-03T12:11:01.671Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Wissen"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "3Zf11Lc9PIKVnQWQjRWKbP",
          "type": "Entry",
          "createdAt": "2019-10-03T12:11:08.242Z",
          "updatedAt": "2019-10-03T12:17:45.013Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Emmental",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "3dlX4Gk7LiWLUzBlfWbt12",
              "type": "Asset",
              "createdAt": "2019-10-03T12:08:59.982Z",
              "updatedAt": "2019-10-03T12:08:59.982Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "manuel-boxler-BbwYJ36B2aw-unsplash",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/3dlX4Gk7LiWLUzBlfWbt12/2ca683b9c7aadd689d7b702db054af1b/manuel-boxler-BbwYJ36B2aw-unsplash.jpg",
                "details": {
                  "size": 2767493,
                  "image": {
                    "width": 5464,
                    "height": 3070
                  }
                },
                "fileName": "manuel-boxler-BbwYJ36B2aw-unsplash.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Deine Reise führt durch das Emmental. Urs' Tip, setze dich auf die linke Seite, dann siehst Du den Napf.",
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1elA60J5VPKasNM6VNpwJY",
              "type": "Entry",
              "createdAt": "2019-10-03T12:11:01.671Z",
              "updatedAt": "2019-10-03T12:11:01.671Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Wissen"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "3rl7t7ykAsQ0h83LFtUtV9",
          "type": "Entry",
          "createdAt": "2019-10-04T11:26:06.645Z",
          "updatedAt": "2019-10-10T13:12:46.534Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 6,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "MANDELBÄRLI",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "563qkH6ApetL6DRMvd5GJh",
              "type": "Asset",
              "createdAt": "2019-10-03T12:09:00.054Z",
              "updatedAt": "2019-10-03T12:09:00.054Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "gang-delicious-5192364-2",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/563qkH6ApetL6DRMvd5GJh/edd38bbdcda22a47679e25789cdb7eb5/gang-delicious-5192364-2.jpg",
                "details": {
                  "size": 130914,
                  "image": {
                    "width": 821,
                    "height": 850
                  }
                },
                "fileName": "gang-delicious-5192364-2.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Hol dir einen von uns ab bei der Bäckerei Glatz - uns gibts schon seid 30 Jahren.",
          "location": {
            "lon": 12.631125093124979,
            "lat": 53.193073272109565
          },
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "2pJge6Pyt7hpbKhEcHunDS",
              "type": "Entry",
              "createdAt": "2019-10-03T12:07:48.634Z",
              "updatedAt": "2019-10-03T12:07:48.634Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Kulinarisch"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "4DsgQ7cy4LS0jirpA9ZAYO",
          "type": "Entry",
          "createdAt": "2019-10-08T08:50:58.568Z",
          "updatedAt": "2019-10-08T08:50:58.568Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Thun",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "H5iujXNQQGhnCKIxjq2Js",
              "type": "Asset",
              "createdAt": "2019-10-02T11:59:49.622Z",
              "updatedAt": "2019-10-02T11:59:49.622Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "Thun",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/H5iujXNQQGhnCKIxjq2Js/70f932f30e16ccdf5783f1c0c1e4f309/IMG_1785-HDR-WRT-Lergier.jpg",
                "details": {
                  "size": 11642879,
                  "image": {
                    "width": 5425,
                    "height": 3617
                  }
                },
                "fileName": "IMG_1785-HDR-WRT-Lergier.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Entdecke die Altstadt und das Schloss in Thun.",
          "location": {
            "lon": 7.627988100000039,
            "lat": 46.7579868
          },
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1nmTM1u3sYcb62YmZAq8Dr",
              "type": "Entry",
              "createdAt": "2019-10-04T09:46:33.431Z",
              "updatedAt": "2019-10-04T11:46:09.278Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Aktivitaet"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "4E9g9yLCZh6guB69fudAqn",
          "type": "Entry",
          "createdAt": "2019-10-08T09:10:41.767Z",
          "updatedAt": "2019-10-08T09:51:28.162Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Berge",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "3mwSrRohxVlXBfmPP14nbA",
              "type": "Asset",
              "createdAt": "2019-10-08T09:08:49.854Z",
              "updatedAt": "2019-10-08T09:08:49.854Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "Meiringen Hasliberg",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/3mwSrRohxVlXBfmPP14nbA/57b4868c21561860d9d0cf7cc71c4926/florian-gretillat-zj_9WewVEw0-unsplash.jpg",
                "details": {
                  "size": 2169578,
                  "image": {
                    "width": 2655,
                    "height": 3975
                  }
                },
                "fileName": "florian-gretillat-zj_9WewVEw0-unsplash.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Mach einen Stop in Meiringen und entdecke zu Fuss die wunderschöne Umgebung.",
          "location": {
            "lon": 8.190908100000001,
            "lat": 46.7251614
          },
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1nmTM1u3sYcb62YmZAq8Dr",
              "type": "Entry",
              "createdAt": "2019-10-04T09:46:33.431Z",
              "updatedAt": "2019-10-04T11:46:09.278Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Aktivitaet"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "4H7SV4DZuSiXtzgIJfMbWq",
          "type": "Entry",
          "createdAt": "2019-10-08T09:57:08.406Z",
          "updatedAt": "2019-10-11T09:26:49.310Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Turm",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1gOT3r97QIiGBjBx6KlwqX",
              "type": "Asset",
              "createdAt": "2019-10-08T09:56:06.932Z",
              "updatedAt": "2019-10-08T09:56:06.932Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "Hexenturm",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/1gOT3r97QIiGBjBx6KlwqX/24147c4039ccff423d9d0767df87dd45/images-10.jpeg",
                "details": {
                  "size": 9063,
                  "image": {
                    "width": 275,
                    "height": 183
                  }
                },
                "fileName": "images-10.jpeg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Der Hexenturm von Sarnen im Kanton Obwalden in der Schweiz ist einer der wenigen noch erhaltenen Burgtürme aus der Zeit der Entstehung der Schweizerischen Eidgenossenschaft. Er wurde um 1285 erbaut und kam um 1315 in den Besitz des Landes Obwalden.",
          "location": {
            "lon": 8.245675799999958,
            "lat": 46.8959313
          },
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1elA60J5VPKasNM6VNpwJY",
              "type": "Entry",
              "createdAt": "2019-10-03T12:11:01.671Z",
              "updatedAt": "2019-10-03T12:11:01.671Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Wissen"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "4TuLPGb9cbptmjF1031XMH",
          "type": "Entry",
          "createdAt": "2019-10-11T08:29:18.794Z",
          "updatedAt": "2019-10-11T08:29:18.794Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Brünigpass",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "7043J1sN0xlS2jSVtJ1Lgd",
              "type": "Asset",
              "createdAt": "2019-10-11T08:27:00.397Z",
              "updatedAt": "2019-10-11T08:27:00.397Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "Brünigpass",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/7043J1sN0xlS2jSVtJ1Lgd/7cf7c820b77f58f6e364b6909d57c8c6/9036620-Brienz.jpg",
                "details": {
                  "size": 1116737,
                  "image": {
                    "width": 2454,
                    "height": 1381
                  }
                },
                "fileName": "9036620-Brienz.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Auf dieser Route kannst auch auf die alte Dampfbahn umsteigen.",
          "location": {
            "lon": 8.136790000000019,
            "lat": 46.7565
          },
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1nmTM1u3sYcb62YmZAq8Dr",
              "type": "Entry",
              "createdAt": "2019-10-04T09:46:33.431Z",
              "updatedAt": "2019-10-04T11:46:09.278Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Aktivitaet"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "4cL0TjiGOhUEj8zs6eQQeJ",
          "type": "Entry",
          "createdAt": "2019-10-03T09:56:44.855Z",
          "updatedAt": "2019-10-09T11:42:51.303Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "routeMode"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Fuss",
          "icon": "walk.svg"
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "4kpOwJHPe4BApkBEIwsliP",
          "type": "Entry",
          "createdAt": "2019-10-04T10:57:03.724Z",
          "updatedAt": "2019-10-04T10:57:03.724Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Zofingen",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "3E3OG3GA4BLQAosOQcTsx4",
              "type": "Asset",
              "createdAt": "2019-10-04T10:15:26.162Z",
              "updatedAt": "2019-10-04T10:15:26.162Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "portrait-home",
              "description": "Zofingen",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/3E3OG3GA4BLQAosOQcTsx4/9f835a72234cbdcefaf121e0f59d343c/portrait-home.jpg",
                "details": {
                  "size": 130144,
                  "image": {
                    "width": 1050,
                    "height": 699
                  }
                },
                "fileName": "portrait-home.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Entdecke die Altstadt und die Villa rustica von Zofingen mit ihrem wunderschönen Mosaikboden.",
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1nmTM1u3sYcb62YmZAq8Dr",
              "type": "Entry",
              "createdAt": "2019-10-04T09:46:33.431Z",
              "updatedAt": "2019-10-04T11:46:09.278Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Aktivitaet"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "4saajFL03n7IF1X7JDXboX",
          "type": "Entry",
          "createdAt": "2019-10-03T12:19:25.747Z",
          "updatedAt": "2019-10-04T11:59:08.221Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "location"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Bern Bahnhof",
          "location": {
            "lon": 7.44041279999999,
            "lat": 46.9476485
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "5L2NTl359ZHtIPvOaMHZmo",
          "type": "Entry",
          "createdAt": "2019-10-03T09:56:26.123Z",
          "updatedAt": "2019-10-09T12:08:27.654Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 3,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "routeMode"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Fahrrad",
          "icon": "bicycle.svg"
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "5XXIacwOxmGUEiL9RSFO6f",
          "type": "Entry",
          "createdAt": "2019-10-08T08:58:54.230Z",
          "updatedAt": "2019-10-10T16:47:45.377Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 4,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r3 Bern Höheweg -Bern Bahnhof",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "6EaG2YTlZFoi9DVXE3PSZh",
                "type": "Entry",
                "createdAt": "2019-10-08T08:48:46.898Z",
                "updatedAt": "2019-10-08T08:49:18.433Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 2,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Brücken",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "4EbL6vJFcER68gikHWucyV",
                    "type": "Asset",
                    "createdAt": "2019-10-08T08:45:58.643Z",
                    "updatedAt": "2019-10-08T08:45:58.643Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Brücken",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/4EbL6vJFcER68gikHWucyV/bb0e96f86d48bb1f414fec5a59f04154/alain-GIWvrROAZE0-unsplash.jpg",
                      "details": {
                        "size": 3757313,
                        "image": {
                          "width": 4000,
                          "height": 6000
                        }
                      },
                      "fileName": "alain-GIWvrROAZE0-unsplash.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Fahr zum Altenbergsteg runter und geniess den Anblick der verschiedenen Brücken die Ruhe an\nder Aare. ",
                "location": {
                  "lon": 7.4486592000000655,
                  "lat": 46.9503949
                },
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1nmTM1u3sYcb62YmZAq8Dr",
                    "type": "Entry",
                    "createdAt": "2019-10-04T09:46:33.431Z",
                    "updatedAt": "2019-10-04T11:46:09.278Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Aktivitaet"
                  }
                }
              }
            },
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "5kJney3TsnDMPMOHnb2mA1",
                "type": "Entry",
                "createdAt": "2019-10-08T08:47:22.318Z",
                "updatedAt": "2019-10-08T08:47:22.318Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "cupcake",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "016GYH36BqhAVd5wZVfsfG",
                    "type": "Asset",
                    "createdAt": "2019-10-08T08:45:26.956Z",
                    "updatedAt": "2019-10-08T08:45:26.956Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "cupcakes",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/016GYH36BqhAVd5wZVfsfG/ac509e4c1cc5f30aa96f9bfd6f292b80/brian-chan-qJ0zGkrE1Zg-unsplash.jpg",
                      "details": {
                        "size": 1424621,
                        "image": {
                          "width": 4272,
                          "height": 2848
                        }
                      },
                      "fileName": "brian-chan-qJ0zGkrE1Zg-unsplash.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Hol dir zur Stärkung einen Cupcake bei Cupcake-Affair Bern. ",
                "location": {
                  "lon": 7.43926799999997,
                  "lat": 46.9475169
                },
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "2pJge6Pyt7hpbKhEcHunDS",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:07:48.634Z",
                    "updatedAt": "2019-10-03T12:07:48.634Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Kulinarisch"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5L2NTl359ZHtIPvOaMHZmo",
              "type": "Entry",
              "createdAt": "2019-10-03T09:56:26.123Z",
              "updatedAt": "2019-10-09T12:08:27.654Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 3,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Fahrrad",
              "icon": "bicycle.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "7J95WjmdU3FWzx0hwPOkJb",
                "type": "Entry",
                "createdAt": "2019-10-03T12:27:59.091Z",
                "updatedAt": "2019-10-03T12:27:59.091Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Bern, Höheweg",
                "location": {
                  "lon": 7.461626840015811,
                  "lat": 46.945792293565205
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "79lgsi0p4GonIr1z8XphVX",
              "type": "Asset",
              "createdAt": "2019-10-10T10:52:24.466Z",
              "updatedAt": "2019-10-10T10:52:24.466Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "map-R3 BernH Bernbahnof",
              "description": "Velo",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/79lgsi0p4GonIr1z8XphVX/5dee0440ac5ef38c925f745be8ef2038/map-R3_BernH_Bernbahnof.geojson",
                "details": {
                  "size": 1700
                },
                "fileName": "map-R3 BernH_Bernbahnof.geojson",
                "contentType": "application/octet-stream"
              }
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "5atGSZfFOc8wM3C3yKO2Zm",
          "type": "Entry",
          "createdAt": "2019-10-07T18:29:05.581Z",
          "updatedAt": "2019-10-10T08:28:37.030Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 3,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r2 Luzern Bahnhof- Luzern St.Karliquai",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "5j1TNJXNUud1o3yZfjrmLP",
                "type": "Entry",
                "createdAt": "2019-10-04T10:41:32.814Z",
                "updatedAt": "2019-10-04T10:41:32.814Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Karls Kraut",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "5F29eu8dZ1jpAYOlQXx8Ej",
                    "type": "Asset",
                    "createdAt": "2019-10-03T12:09:00.317Z",
                    "updatedAt": "2019-10-03T12:09:00.317Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "jovana-askrabic-vEBsRMCis-c-unsplash",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/5F29eu8dZ1jpAYOlQXx8Ej/ad82f0380ff9a2745cfef2e2e9039066/jovana-askrabic-vEBsRMCis-c-unsplash.jpg",
                      "details": {
                        "size": 2182061,
                        "image": {
                          "width": 4534,
                          "height": 3023
                        }
                      },
                      "fileName": "jovana-askrabic-vEBsRMCis-c-unsplash.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Du hast dein Ziel erreicht. Bist Du hungrig? Urs\nhat noch einen tollen Tip für Dich.\nURS Tip: Restaurante Karls Kraut",
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "2pJge6Pyt7hpbKhEcHunDS",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:07:48.634Z",
                    "updatedAt": "2019-10-03T12:07:48.634Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Kulinarisch"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "4cL0TjiGOhUEj8zs6eQQeJ",
              "type": "Entry",
              "createdAt": "2019-10-03T09:56:44.855Z",
              "updatedAt": "2019-10-09T11:42:51.303Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Fuss",
              "icon": "walk.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "xTDNC3LU936C1gjVmvFXk",
                "type": "Entry",
                "createdAt": "2019-10-03T12:19:45.941Z",
                "updatedAt": "2019-10-03T12:19:45.941Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Luzern",
                "location": {
                  "lon": 8.310826200000065,
                  "lat": 47.0507934
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1uu4eZblrkiJuGeKcGnotY",
              "type": "Asset",
              "createdAt": "2019-10-10T08:28:09.513Z",
              "updatedAt": "2019-10-10T08:28:09.513Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "map-R2 LuzernBahnhof Luzern Karli",
              "description": "zu Fuss",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/1uu4eZblrkiJuGeKcGnotY/ed4abd075d309ee5081b2b2d7ce5ae90/map-R2_LuzernBahnhof_Luzern_Karli.geojson",
                "details": {
                  "size": 1047
                },
                "fileName": "map-R2_LuzernBahnhof_Luzern_Karli.geojson",
                "contentType": "application/octet-stream"
              }
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "5fEUtCWMCNp4Efb3ySN9Dh",
          "type": "Entry",
          "createdAt": "2019-10-08T09:55:32.172Z",
          "updatedAt": "2019-10-11T08:30:34.267Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 5,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r3 Meiringen- Luzern Bahnhof",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "4TuLPGb9cbptmjF1031XMH",
                "type": "Entry",
                "createdAt": "2019-10-11T08:29:18.794Z",
                "updatedAt": "2019-10-11T08:29:18.794Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Brünigpass",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "7043J1sN0xlS2jSVtJ1Lgd",
                    "type": "Asset",
                    "createdAt": "2019-10-11T08:27:00.397Z",
                    "updatedAt": "2019-10-11T08:27:00.397Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Brünigpass",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/7043J1sN0xlS2jSVtJ1Lgd/7cf7c820b77f58f6e364b6909d57c8c6/9036620-Brienz.jpg",
                      "details": {
                        "size": 1116737,
                        "image": {
                          "width": 2454,
                          "height": 1381
                        }
                      },
                      "fileName": "9036620-Brienz.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Auf dieser Route kannst auch auf die alte Dampfbahn umsteigen.",
                "location": {
                  "lon": 8.136790000000019,
                  "lat": 46.7565
                },
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1nmTM1u3sYcb62YmZAq8Dr",
                    "type": "Entry",
                    "createdAt": "2019-10-04T09:46:33.431Z",
                    "updatedAt": "2019-10-04T11:46:09.278Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Aktivitaet"
                  }
                }
              }
            },
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "4H7SV4DZuSiXtzgIJfMbWq",
                "type": "Entry",
                "createdAt": "2019-10-08T09:57:08.406Z",
                "updatedAt": "2019-10-11T09:26:49.310Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 2,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Turm",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1gOT3r97QIiGBjBx6KlwqX",
                    "type": "Asset",
                    "createdAt": "2019-10-08T09:56:06.932Z",
                    "updatedAt": "2019-10-08T09:56:06.932Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Hexenturm",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/1gOT3r97QIiGBjBx6KlwqX/24147c4039ccff423d9d0767df87dd45/images-10.jpeg",
                      "details": {
                        "size": 9063,
                        "image": {
                          "width": 275,
                          "height": 183
                        }
                      },
                      "fileName": "images-10.jpeg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Der Hexenturm von Sarnen im Kanton Obwalden in der Schweiz ist einer der wenigen noch erhaltenen Burgtürme aus der Zeit der Entstehung der Schweizerischen Eidgenossenschaft. Er wurde um 1285 erbaut und kam um 1315 in den Besitz des Landes Obwalden.",
                "location": {
                  "lon": 8.245675799999958,
                  "lat": 46.8959313
                },
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1elA60J5VPKasNM6VNpwJY",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:11:01.671Z",
                    "updatedAt": "2019-10-03T12:11:01.671Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Wissen"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5ziMOVnwRUM5iU5cZrsxk",
              "type": "Entry",
              "createdAt": "2019-10-03T09:57:07.808Z",
              "updatedAt": "2019-10-09T11:42:40.159Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Zug",
              "icon": "train.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "2uxCV0AUKKtxZaW9yQcASH",
                "type": "Entry",
                "createdAt": "2019-10-08T09:13:49.393Z",
                "updatedAt": "2019-10-08T09:13:49.393Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Meiringen-Hasliberg",
                "location": {
                  "lon": 8.190908100000001,
                  "lat": 46.7251614
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "2ERiPx0iyVJ4qiArie7gzj",
              "type": "Asset",
              "createdAt": "2019-10-10T11:33:29.676Z",
              "updatedAt": "2019-10-10T11:33:29.676Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "map-R3 Meiringen LuzernBahnhof",
              "description": "Zug, Fuss",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/2ERiPx0iyVJ4qiArie7gzj/8e691aabc6270d48139ddb6b2c6d3535/map-R3__Meiringen_LuzernBahnhof.geojson",
                "details": {
                  "size": 4370
                },
                "fileName": "map-R3_ Meiringen_LuzernBahnhof.geojson",
                "contentType": "application/octet-stream"
              }
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "5j1TNJXNUud1o3yZfjrmLP",
          "type": "Entry",
          "createdAt": "2019-10-04T10:41:32.814Z",
          "updatedAt": "2019-10-04T10:41:32.814Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Karls Kraut",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5F29eu8dZ1jpAYOlQXx8Ej",
              "type": "Asset",
              "createdAt": "2019-10-03T12:09:00.317Z",
              "updatedAt": "2019-10-03T12:09:00.317Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "jovana-askrabic-vEBsRMCis-c-unsplash",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/5F29eu8dZ1jpAYOlQXx8Ej/ad82f0380ff9a2745cfef2e2e9039066/jovana-askrabic-vEBsRMCis-c-unsplash.jpg",
                "details": {
                  "size": 2182061,
                  "image": {
                    "width": 4534,
                    "height": 3023
                  }
                },
                "fileName": "jovana-askrabic-vEBsRMCis-c-unsplash.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Du hast dein Ziel erreicht. Bist Du hungrig? Urs\nhat noch einen tollen Tip für Dich.\nURS Tip: Restaurante Karls Kraut",
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "2pJge6Pyt7hpbKhEcHunDS",
              "type": "Entry",
              "createdAt": "2019-10-03T12:07:48.634Z",
              "updatedAt": "2019-10-03T12:07:48.634Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Kulinarisch"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "5kJney3TsnDMPMOHnb2mA1",
          "type": "Entry",
          "createdAt": "2019-10-08T08:47:22.318Z",
          "updatedAt": "2019-10-08T08:47:22.318Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "cupcake",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "016GYH36BqhAVd5wZVfsfG",
              "type": "Asset",
              "createdAt": "2019-10-08T08:45:26.956Z",
              "updatedAt": "2019-10-08T08:45:26.956Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "cupcakes",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/016GYH36BqhAVd5wZVfsfG/ac509e4c1cc5f30aa96f9bfd6f292b80/brian-chan-qJ0zGkrE1Zg-unsplash.jpg",
                "details": {
                  "size": 1424621,
                  "image": {
                    "width": 4272,
                    "height": 2848
                  }
                },
                "fileName": "brian-chan-qJ0zGkrE1Zg-unsplash.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Hol dir zur Stärkung einen Cupcake bei Cupcake-Affair Bern. ",
          "location": {
            "lon": 7.43926799999997,
            "lat": 46.9475169
          },
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "2pJge6Pyt7hpbKhEcHunDS",
              "type": "Entry",
              "createdAt": "2019-10-03T12:07:48.634Z",
              "updatedAt": "2019-10-03T12:07:48.634Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Kulinarisch"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "5ukypyl8EWHJw6Z2ou6umL",
          "type": "Entry",
          "createdAt": "2019-10-04T11:29:48.426Z",
          "updatedAt": "2019-10-09T14:31:46.104Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 6,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r2 Bern- Langnau i. E.",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "3Zf11Lc9PIKVnQWQjRWKbP",
                "type": "Entry",
                "createdAt": "2019-10-03T12:11:08.242Z",
                "updatedAt": "2019-10-03T12:17:45.013Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 2,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Emmental",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "3dlX4Gk7LiWLUzBlfWbt12",
                    "type": "Asset",
                    "createdAt": "2019-10-03T12:08:59.982Z",
                    "updatedAt": "2019-10-03T12:08:59.982Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "manuel-boxler-BbwYJ36B2aw-unsplash",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/3dlX4Gk7LiWLUzBlfWbt12/2ca683b9c7aadd689d7b702db054af1b/manuel-boxler-BbwYJ36B2aw-unsplash.jpg",
                      "details": {
                        "size": 2767493,
                        "image": {
                          "width": 5464,
                          "height": 3070
                        }
                      },
                      "fileName": "manuel-boxler-BbwYJ36B2aw-unsplash.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Deine Reise führt durch das Emmental. Urs' Tip, setze dich auf die linke Seite, dann siehst Du den Napf.",
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1elA60J5VPKasNM6VNpwJY",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:11:01.671Z",
                    "updatedAt": "2019-10-03T12:11:01.671Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Wissen"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5ziMOVnwRUM5iU5cZrsxk",
              "type": "Entry",
              "createdAt": "2019-10-03T09:57:07.808Z",
              "updatedAt": "2019-10-09T11:42:40.159Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Zug",
              "icon": "train.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "4saajFL03n7IF1X7JDXboX",
                "type": "Entry",
                "createdAt": "2019-10-03T12:19:25.747Z",
                "updatedAt": "2019-10-04T11:59:08.221Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 2,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Bern Bahnhof",
                "location": {
                  "lon": 7.44041279999999,
                  "lat": 46.9476485
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5q00Mod2WjBFXrYXFZ0osC",
              "type": "Asset",
              "createdAt": "2019-10-09T11:46:01.424Z",
              "updatedAt": "2019-10-09T11:53:01.341Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 3,
              "locale": "en-US"
            },
            "fields": {
              "title": "R2 BernBahnhof- Langnau i. E.",
              "description": "R2 Bahn BernBahnhof- Langnau i. E.",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/5q00Mod2WjBFXrYXFZ0osC/c182af188a035a920969b8e552198440/map-R2._BernB_Langnau.geojson",
                "details": {
                  "size": 1291
                },
                "fileName": "map-R2._BernB_Langnau.geojson",
                "contentType": "application/octet-stream"
              }
            }
          },
          "testroute": {
            "type": "FeatureCollection",
            "features": [
              {
                "type": "Feature",
                "geometry": {
                  "type": "LineString",
                  "coordinates": [
                    [
                      7.438859939575194,
                      46.94950055560101
                    ],
                    [
                      7.442893981933593,
                      46.95518364804432
                    ],
                    [
                      7.44349479675293,
                      46.95975311968452
                    ],
                    [
                      7.447271347045898,
                      46.96326783233767
                    ],
                    [
                      7.463665008544922,
                      46.96736803860756
                    ],
                    [
                      7.476968765258788,
                      46.963736443245985
                    ],
                    [
                      7.4808311462402335,
                      46.960397500956084
                    ],
                    [
                      7.4829769134521475,
                      46.95166840432543
                    ],
                    [
                      7.491731643676757,
                      46.94235189176862
                    ],
                    [
                      7.509326934814452,
                      46.93197877238813
                    ],
                    [
                      7.523231506347656,
                      46.92471053128251
                    ],
                    [
                      7.536621093749999,
                      46.925413952558074
                    ],
                    [
                      7.552585601806641,
                      46.915565214159955
                    ],
                    [
                      7.56580352783203,
                      46.91509618145963
                    ],
                    [
                      7.574729919433595,
                      46.911578305351505
                    ],
                    [
                      7.57781982421875,
                      46.88894111413941
                    ],
                    [
                      7.583312988281249,
                      46.880611037981254
                    ],
                    [
                      7.596702575683594,
                      46.877442923060784
                    ],
                    [
                      7.619361877441405,
                      46.878968335076856
                    ],
                    [
                      7.657470703124999,
                      46.89633150707981
                    ],
                    [
                      7.666740417480469,
                      46.90243074674521
                    ],
                    [
                      7.6815032958984375,
                      46.89938121363944
                    ],
                    [
                      7.704505920410156,
                      46.90219617343362
                    ],
                    [
                      7.735404968261718,
                      46.927524160965085
                    ],
                    [
                      7.736434936523438,
                      46.93807395606992
                    ],
                    [
                      7.748451232910156,
                      46.94721543080955
                    ],
                    [
                      7.752571105957031,
                      46.95237147154127
                    ],
                    [
                      7.778320312499999,
                      46.941355690698636
                    ],
                    [
                      7.785873413085937,
                      46.93690185924091
                    ]
                  ]
                },
                "properties": {
                  "strokeColor": "red",
                  "stroke-width": 4,
                  "stroke-opacity": 1
                }
              }
            ]
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "5ziMOVnwRUM5iU5cZrsxk",
          "type": "Entry",
          "createdAt": "2019-10-03T09:57:07.808Z",
          "updatedAt": "2019-10-09T11:42:40.159Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "routeMode"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Zug",
          "icon": "train.svg"
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "61Xs1TfFwkh06lS4RSG3fX",
          "type": "Entry",
          "createdAt": "2019-10-07T21:44:03.829Z",
          "updatedAt": "2019-10-09T10:56:21.226Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Adrianos",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1bM76eqaSDR9H1bl1UXAp6",
              "type": "Asset",
              "createdAt": "2019-10-04T10:14:55.880Z",
              "updatedAt": "2019-10-04T10:14:55.880Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "dario-DLrRYHBydj4-unsplash",
              "description": "Adrianos\n",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/1bM76eqaSDR9H1bl1UXAp6/14fb778d0c8afccad4faf5b8a62c0e1f/dario-DLrRYHBydj4-unsplash.jpg",
                "details": {
                  "size": 2400378,
                  "image": {
                    "width": 3036,
                    "height": 4048
                  }
                },
                "fileName": "dario-DLrRYHBydj4-unsplash.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Hol dir einen Kaffe in der Adrianos Bar. Adrianos hat eine Hauseigene Rösterei in der Alten Feuerwehr Viktoria in Bern.",
          "location": {
            "lon": 7.447254199999975,
            "lat": 46.9478491
          },
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "2pJge6Pyt7hpbKhEcHunDS",
              "type": "Entry",
              "createdAt": "2019-10-03T12:07:48.634Z",
              "updatedAt": "2019-10-03T12:07:48.634Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Kulinarisch"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "68BiEk7i19wmAcG0je2gom",
          "type": "Entry",
          "createdAt": "2019-10-08T09:02:22.113Z",
          "updatedAt": "2019-10-09T11:18:17.074Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Thunersee",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "48sDwwqaq8yzHhapdigeXx",
              "type": "Asset",
              "createdAt": "2019-10-08T08:44:36.667Z",
              "updatedAt": "2019-10-08T08:44:36.667Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "Thunersee",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/48sDwwqaq8yzHhapdigeXx/8bd55a0dbe170707c34594ef4649ac1e/prakarsh-saxena-k4AoLA76NRc-unsplash.jpg",
                "details": {
                  "size": 3299553,
                  "image": {
                    "width": 5184,
                    "height": 2920
                  }
                },
                "fileName": "prakarsh-saxena-k4AoLA76NRc-unsplash.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Stand-up paddle auf dem Thuner oder Brienzersee",
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1nmTM1u3sYcb62YmZAq8Dr",
              "type": "Entry",
              "createdAt": "2019-10-04T09:46:33.431Z",
              "updatedAt": "2019-10-04T11:46:09.278Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Aktivitaet"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "6CmgoIz5BnsMtCJ6yfAhqn",
          "type": "Entry",
          "createdAt": "2019-10-08T09:03:52.605Z",
          "updatedAt": "2019-10-10T16:47:32.476Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 3,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r3 Bern Bahnhof - Interlaken Bahnhof",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "4DsgQ7cy4LS0jirpA9ZAYO",
                "type": "Entry",
                "createdAt": "2019-10-08T08:50:58.568Z",
                "updatedAt": "2019-10-08T08:50:58.568Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Thun",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "H5iujXNQQGhnCKIxjq2Js",
                    "type": "Asset",
                    "createdAt": "2019-10-02T11:59:49.622Z",
                    "updatedAt": "2019-10-02T11:59:49.622Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Thun",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/H5iujXNQQGhnCKIxjq2Js/70f932f30e16ccdf5783f1c0c1e4f309/IMG_1785-HDR-WRT-Lergier.jpg",
                      "details": {
                        "size": 11642879,
                        "image": {
                          "width": 5425,
                          "height": 3617
                        }
                      },
                      "fileName": "IMG_1785-HDR-WRT-Lergier.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Entdecke die Altstadt und das Schloss in Thun.",
                "location": {
                  "lon": 7.627988100000039,
                  "lat": 46.7579868
                },
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1nmTM1u3sYcb62YmZAq8Dr",
                    "type": "Entry",
                    "createdAt": "2019-10-04T09:46:33.431Z",
                    "updatedAt": "2019-10-04T11:46:09.278Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Aktivitaet"
                  }
                }
              }
            },
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "68BiEk7i19wmAcG0je2gom",
                "type": "Entry",
                "createdAt": "2019-10-08T09:02:22.113Z",
                "updatedAt": "2019-10-09T11:18:17.074Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 2,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Thunersee",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "48sDwwqaq8yzHhapdigeXx",
                    "type": "Asset",
                    "createdAt": "2019-10-08T08:44:36.667Z",
                    "updatedAt": "2019-10-08T08:44:36.667Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Thunersee",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/48sDwwqaq8yzHhapdigeXx/8bd55a0dbe170707c34594ef4649ac1e/prakarsh-saxena-k4AoLA76NRc-unsplash.jpg",
                      "details": {
                        "size": 3299553,
                        "image": {
                          "width": 5184,
                          "height": 2920
                        }
                      },
                      "fileName": "prakarsh-saxena-k4AoLA76NRc-unsplash.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Stand-up paddle auf dem Thuner oder Brienzersee",
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1nmTM1u3sYcb62YmZAq8Dr",
                    "type": "Entry",
                    "createdAt": "2019-10-04T09:46:33.431Z",
                    "updatedAt": "2019-10-04T11:46:09.278Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Aktivitaet"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5ziMOVnwRUM5iU5cZrsxk",
              "type": "Entry",
              "createdAt": "2019-10-03T09:57:07.808Z",
              "updatedAt": "2019-10-09T11:42:40.159Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Zug",
              "icon": "train.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "4saajFL03n7IF1X7JDXboX",
                "type": "Entry",
                "createdAt": "2019-10-03T12:19:25.747Z",
                "updatedAt": "2019-10-04T11:59:08.221Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 2,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Bern Bahnhof",
                "location": {
                  "lon": 7.44041279999999,
                  "lat": 46.9476485
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "66a0prYBagbqkTccJiQ7IM",
              "type": "Asset",
              "createdAt": "2019-10-10T11:04:56.800Z",
              "updatedAt": "2019-10-10T11:04:56.800Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "map-R3 Bernbahnhof Interlaken",
              "description": "Zug",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/66a0prYBagbqkTccJiQ7IM/466813b0dc36538279b057609fbf4e73/map-R3_Bernbahnhof_Interlaken.geojson",
                "details": {
                  "size": 3290
                },
                "fileName": "map-R3_Bernbahnhof_Interlaken.geojson",
                "contentType": "application/octet-stream"
              }
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "6EaG2YTlZFoi9DVXE3PSZh",
          "type": "Entry",
          "createdAt": "2019-10-08T08:48:46.898Z",
          "updatedAt": "2019-10-08T08:49:18.433Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Brücken",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "4EbL6vJFcER68gikHWucyV",
              "type": "Asset",
              "createdAt": "2019-10-08T08:45:58.643Z",
              "updatedAt": "2019-10-08T08:45:58.643Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "Brücken",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/4EbL6vJFcER68gikHWucyV/bb0e96f86d48bb1f414fec5a59f04154/alain-GIWvrROAZE0-unsplash.jpg",
                "details": {
                  "size": 3757313,
                  "image": {
                    "width": 4000,
                    "height": 6000
                  }
                },
                "fileName": "alain-GIWvrROAZE0-unsplash.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Fahr zum Altenbergsteg runter und geniess den Anblick der verschiedenen Brücken die Ruhe an\nder Aare. ",
          "location": {
            "lon": 7.4486592000000655,
            "lat": 46.9503949
          },
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1nmTM1u3sYcb62YmZAq8Dr",
              "type": "Entry",
              "createdAt": "2019-10-04T09:46:33.431Z",
              "updatedAt": "2019-10-04T11:46:09.278Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Aktivitaet"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "6JzsjxitsiPbjtGXC2QfZL",
          "type": "Entry",
          "createdAt": "2019-10-03T12:26:07.076Z",
          "updatedAt": "2019-10-08T06:40:34.359Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 4,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "MÜNSTER",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1zHnn6bNw7wCo7KtJH6nEg",
              "type": "Asset",
              "createdAt": "2019-10-03T12:08:59.978Z",
              "updatedAt": "2019-10-03T12:08:59.978Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "nicolas-jossi-sXqap3 VbWI-unsplash",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/1zHnn6bNw7wCo7KtJH6nEg/fd3fe0c80f8374b0573571a056731a0f/nicolas-jossi-sXqap3_VbWI-unsplash.jpg",
                "details": {
                  "size": 463248,
                  "image": {
                    "width": 1653,
                    "height": 2652
                  }
                },
                "fileName": "nicolas-jossi-sXqap3_VbWI-unsplash.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Mit einer Velofahrt durch die Berner Altstadt kannst du auf deinem Weg UNESCO Kulturerbe geniessen. Im Herzen der mittelalterlichen Stadt ist das Berner Münster, ein Hauptwerk der schweizerischen Spätgotik. Die Grundsteinlegung erfolgte 1421.",
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1elA60J5VPKasNM6VNpwJY",
              "type": "Entry",
              "createdAt": "2019-10-03T12:11:01.671Z",
              "updatedAt": "2019-10-03T12:11:01.671Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Wissen"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "6PSOXGUVYmVoeQNgbOa2wH",
          "type": "Entry",
          "createdAt": "2019-10-04T11:32:23.561Z",
          "updatedAt": "2019-10-04T11:42:22.151Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 3,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "location"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Langnau i. E.",
          "location": {
            "lon": 7.784992999999986,
            "lat": 46.93885
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "6aH2W4je7xZg5Tw25yTrBk",
          "type": "Entry",
          "createdAt": "2019-10-04T10:25:00.193Z",
          "updatedAt": "2019-10-09T12:40:54.453Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 7,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r2 Trubschachen - Luzern",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "6yswJXF4UgCVWDdwkIGMlE",
                "type": "Entry",
                "createdAt": "2019-10-04T10:43:42.447Z",
                "updatedAt": "2019-10-04T10:50:12.817Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 2,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Änzilochgeist",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "5Ig7KvBKBY5O8MSwR0c3yw",
                    "type": "Asset",
                    "createdAt": "2019-10-03T12:09:00.127Z",
                    "updatedAt": "2019-10-03T12:09:00.127Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "csm 01 AEnziloch 01 Typo3 698cb5cacc",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/5Ig7KvBKBY5O8MSwR0c3yw/7f0ce3680c5bf790f4d6421fb306a866/csm_01_AEnziloch_01_Typo3_698cb5cacc.jpg",
                      "details": {
                        "size": 241259,
                        "image": {
                          "width": 1280,
                          "height": 727
                        }
                      },
                      "fileName": "csm_01_AEnziloch_01_Typo3_698cb5cacc.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Du hast das Entlebuch erreicht, wo es  unzählige Sagen gibt.\nHör Dir auf der Zugfahrt die Sage vom Änzilochgeist an. ",
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1elA60J5VPKasNM6VNpwJY",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:11:01.671Z",
                    "updatedAt": "2019-10-03T12:11:01.671Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Wissen"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5ziMOVnwRUM5iU5cZrsxk",
              "type": "Entry",
              "createdAt": "2019-10-03T09:57:07.808Z",
              "updatedAt": "2019-10-09T11:42:40.159Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Zug",
              "icon": "train.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "28QH3BsxVaoqFqUgtUpAE9",
                "type": "Entry",
                "createdAt": "2019-10-03T12:17:00.410Z",
                "updatedAt": "2019-10-03T12:17:00.411Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Trubschachen",
                "location": {
                  "lon": 7.846130784061415,
                  "lat": 46.92169147842277
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "30hHywqltv5XhCokIhn5HC",
              "type": "Asset",
              "createdAt": "2019-10-09T12:40:28.571Z",
              "updatedAt": "2019-10-09T12:40:28.571Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "map-R2 Trubschachen Luzern",
              "description": "Zug map-R2 Trubschachen Luzern",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/30hHywqltv5XhCokIhn5HC/04b2e9a80f09e8e9f38139971e048636/map-R2_Trubschachen_Luzern.geojson",
                "details": {
                  "size": 3379
                },
                "fileName": "map-R2_Trubschachen_Luzern.geojson",
                "contentType": "application/octet-stream"
              }
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "6pTiETdCZW0um4kl0iS0kN",
          "type": "Entry",
          "createdAt": "2019-10-08T08:52:30.838Z",
          "updatedAt": "2019-10-08T08:52:30.838Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Gelateria",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "wKSVz3kp8Xnub8B3Z62CI",
              "type": "Asset",
              "createdAt": "2019-10-08T08:44:06.701Z",
              "updatedAt": "2019-10-08T08:44:06.701Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "Gelateria",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/wKSVz3kp8Xnub8B3Z62CI/ea791f4ad74b5b686d4130cdea3bc2d2/csm_Luzern_Listicals_Glace_IMG_7133-Bearbeitet_Typo3_c2ff9376d8.jpg",
                "details": {
                  "size": 77583,
                  "image": {
                    "width": 1280,
                    "height": 727
                  }
                },
                "fileName": "csm_Luzern_Listicals_Glace_IMG_7133-Bearbeitet_Typo3_c2ff9376d8.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Du hast dein Ziel erreicht.\nUrs hat noch einen tollen Tip für Dich.\n\nURS Tip: Gelateria del Alpi",
          "location": {
            "lon": 8.310362899999973,
            "lat": 47.0579679
          },
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "2pJge6Pyt7hpbKhEcHunDS",
              "type": "Entry",
              "createdAt": "2019-10-03T12:07:48.634Z",
              "updatedAt": "2019-10-03T12:07:48.634Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Kulinarisch"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "6yswJXF4UgCVWDdwkIGMlE",
          "type": "Entry",
          "createdAt": "2019-10-04T10:43:42.447Z",
          "updatedAt": "2019-10-04T10:50:12.817Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Änzilochgeist",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5Ig7KvBKBY5O8MSwR0c3yw",
              "type": "Asset",
              "createdAt": "2019-10-03T12:09:00.127Z",
              "updatedAt": "2019-10-03T12:09:00.127Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "csm 01 AEnziloch 01 Typo3 698cb5cacc",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/5Ig7KvBKBY5O8MSwR0c3yw/7f0ce3680c5bf790f4d6421fb306a866/csm_01_AEnziloch_01_Typo3_698cb5cacc.jpg",
                "details": {
                  "size": 241259,
                  "image": {
                    "width": 1280,
                    "height": 727
                  }
                },
                "fileName": "csm_01_AEnziloch_01_Typo3_698cb5cacc.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Du hast das Entlebuch erreicht, wo es  unzählige Sagen gibt.\nHör Dir auf der Zugfahrt die Sage vom Änzilochgeist an. ",
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1elA60J5VPKasNM6VNpwJY",
              "type": "Entry",
              "createdAt": "2019-10-03T12:11:01.671Z",
              "updatedAt": "2019-10-03T12:11:01.671Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Wissen"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "7J95WjmdU3FWzx0hwPOkJb",
          "type": "Entry",
          "createdAt": "2019-10-03T12:27:59.091Z",
          "updatedAt": "2019-10-03T12:27:59.091Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "location"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Bern, Höheweg",
          "location": {
            "lon": 7.461626840015811,
            "lat": 46.945792293565205
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "7LCVWRlPEm8N8FlzSfH16c",
          "type": "Entry",
          "createdAt": "2019-10-03T10:49:13.634Z",
          "updatedAt": "2019-10-10T19:20:30.892Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 6,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r1 Bern - Luzern ",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "2qbII0SeGM07kSnu300jmN",
                "type": "Entry",
                "createdAt": "2019-10-04T11:15:13.880Z",
                "updatedAt": "2019-10-09T11:03:09.608Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 2,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Herzogenbuchsee",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "Ffe1iaLvziHO989F4srti",
                    "type": "Asset",
                    "createdAt": "2019-10-04T11:16:00.939Z",
                    "updatedAt": "2019-10-04T11:16:00.939Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "kreuz herzogenbuchsee herzogenbuchsee 3360 herzogenbuchsee kreuz01 aussen",
                    "description": "Herzogenbuchsee",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/Ffe1iaLvziHO989F4srti/9f742b7982d0423a8897cf3daab86bee/kreuz_herzogenbuchsee_herzogenbuchsee_3360_herzogenbuchsee_kreuz01_aussen.jpg",
                      "details": {
                        "size": 4369954,
                        "image": {
                          "width": 3573,
                          "height": 2385
                        }
                      },
                      "fileName": "kreuz_herzogenbuchsee_herzogenbuchsee_3360_herzogenbuchsee_kreuz01_aussen.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Bereits vor zehntausend Jahren war die Gegend besiedelt. An verschiedenen Stellen rund um die heutige reformierte Kirche wurden Fundamente von römischen Gebäuden aus der Zeit um 200 n. Chr. gefunden.",
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1elA60J5VPKasNM6VNpwJY",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:11:01.671Z",
                    "updatedAt": "2019-10-03T12:11:01.671Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Wissen"
                  }
                }
              }
            },
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "4kpOwJHPe4BApkBEIwsliP",
                "type": "Entry",
                "createdAt": "2019-10-04T10:57:03.724Z",
                "updatedAt": "2019-10-04T10:57:03.724Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Zofingen",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "3E3OG3GA4BLQAosOQcTsx4",
                    "type": "Asset",
                    "createdAt": "2019-10-04T10:15:26.162Z",
                    "updatedAt": "2019-10-04T10:15:26.162Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "portrait-home",
                    "description": "Zofingen",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/3E3OG3GA4BLQAosOQcTsx4/9f835a72234cbdcefaf121e0f59d343c/portrait-home.jpg",
                      "details": {
                        "size": 130144,
                        "image": {
                          "width": 1050,
                          "height": 699
                        }
                      },
                      "fileName": "portrait-home.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Entdecke die Altstadt und die Villa rustica von Zofingen mit ihrem wunderschönen Mosaikboden.",
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1nmTM1u3sYcb62YmZAq8Dr",
                    "type": "Entry",
                    "createdAt": "2019-10-04T09:46:33.431Z",
                    "updatedAt": "2019-10-04T11:46:09.278Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Aktivitaet"
                  }
                }
              }
            },
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "7pyx7cth7YaSo6sxCN27Rf",
                "type": "Entry",
                "createdAt": "2019-10-04T10:55:15.676Z",
                "updatedAt": "2019-10-04T10:55:15.676Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Sempachersee",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "4yM5WoNgaczWkAkgtnSdFu",
                    "type": "Asset",
                    "createdAt": "2019-10-04T10:13:47.853Z",
                    "updatedAt": "2019-10-04T10:14:22.956Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "csm_blick-auf-sempachersee-herbst_1_907be51842",
                    "description": "Sepachersee\n",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/4yM5WoNgaczWkAkgtnSdFu/035eb626d3a5678657f8da1a213a053e/csm_blick-auf-sempachersee-herbst_1_907be51842.jpg",
                      "details": {
                        "size": 234969,
                        "image": {
                          "width": 1280,
                          "height": 727
                        }
                      },
                      "fileName": "csm_blick-auf-sempachersee-herbst_1_907be51842.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Sempacherschlacht war die entscheidende Schlacht im Sempacherkrieg zwischen der sich entwickelnden Eidgenossenschaft und dem Herzogtum Österreich, der von 1385 bis 1389 dauerte.",
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1elA60J5VPKasNM6VNpwJY",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:11:01.671Z",
                    "updatedAt": "2019-10-03T12:11:01.671Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Wissen"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "5ziMOVnwRUM5iU5cZrsxk",
              "type": "Entry",
              "createdAt": "2019-10-03T09:57:07.808Z",
              "updatedAt": "2019-10-09T11:42:40.159Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Zug",
              "icon": "train.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "4saajFL03n7IF1X7JDXboX",
                "type": "Entry",
                "createdAt": "2019-10-03T12:19:25.747Z",
                "updatedAt": "2019-10-04T11:59:08.221Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 2,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Bern Bahnhof",
                "location": {
                  "lon": 7.44041279999999,
                  "lat": 46.9476485
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "2DmgRgy9v6KlwP8Nu6q9E2",
              "type": "Asset",
              "createdAt": "2019-10-10T09:06:01.304Z",
              "updatedAt": "2019-10-10T09:06:01.304Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "map-R1 BernBahnhof LuzernB",
              "description": "Zug",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/2DmgRgy9v6KlwP8Nu6q9E2/b6fde7c696ff2bf465b6f5c22f322897/map-R1_BernBahnhof_LuzernB.geojson",
                "details": {
                  "size": 4002
                },
                "fileName": "map-R1_BernBahnhof_LuzernB.geojson",
                "contentType": "application/octet-stream"
              }
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "7cmB82HJELQCvgfPJibV4E",
          "type": "Entry",
          "createdAt": "2019-10-04T11:40:23.080Z",
          "updatedAt": "2019-10-10T12:44:37.463Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 3,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r2 Langnau i.E.",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "2sppJNBXCpnUqWo4vUsnbw",
                "type": "Entry",
                "createdAt": "2019-10-03T12:12:44.709Z",
                "updatedAt": "2019-10-04T09:48:14.266Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 3,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Chüechlihus",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "5RxlYgOahrEEEYIDoUBaBR",
                    "type": "Asset",
                    "createdAt": "2019-10-03T12:09:00.290Z",
                    "updatedAt": "2019-10-03T12:09:00.290Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "emmental-ausflugstipps-chechlihus-langnau",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/5RxlYgOahrEEEYIDoUBaBR/28ae1cf5dc3f9f66bc11dff62e08718c/emmental-ausflugstipps-chechlihus-langnau.jpg",
                      "details": {
                        "size": 401110,
                        "image": {
                          "width": 1920,
                          "height": 1281
                        }
                      },
                      "fileName": "emmental-ausflugstipps-chechlihus-langnau.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Das Chüechlihus aus dem Jahr 1526 ist das älteste, weitgehend original erhaltene Holzgebäude der Region.",
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1nmTM1u3sYcb62YmZAq8Dr",
                    "type": "Entry",
                    "createdAt": "2019-10-04T09:46:33.431Z",
                    "updatedAt": "2019-10-04T11:46:09.278Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Aktivitaet"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "4cL0TjiGOhUEj8zs6eQQeJ",
              "type": "Entry",
              "createdAt": "2019-10-03T09:56:44.855Z",
              "updatedAt": "2019-10-09T11:42:51.303Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Fuss",
              "icon": "walk.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "6PSOXGUVYmVoeQNgbOa2wH",
                "type": "Entry",
                "createdAt": "2019-10-04T11:32:23.561Z",
                "updatedAt": "2019-10-04T11:42:22.151Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 3,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Langnau i. E.",
                "location": {
                  "lon": 7.784992999999986,
                  "lat": 46.93885
                }
              }
            }
          ]
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "7pyx7cth7YaSo6sxCN27Rf",
          "type": "Entry",
          "createdAt": "2019-10-04T10:55:15.676Z",
          "updatedAt": "2019-10-04T10:55:15.676Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Sempachersee",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "4yM5WoNgaczWkAkgtnSdFu",
              "type": "Asset",
              "createdAt": "2019-10-04T10:13:47.853Z",
              "updatedAt": "2019-10-04T10:14:22.956Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "locale": "en-US"
            },
            "fields": {
              "title": "csm_blick-auf-sempachersee-herbst_1_907be51842",
              "description": "Sepachersee\n",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/4yM5WoNgaczWkAkgtnSdFu/035eb626d3a5678657f8da1a213a053e/csm_blick-auf-sempachersee-herbst_1_907be51842.jpg",
                "details": {
                  "size": 234969,
                  "image": {
                    "width": 1280,
                    "height": 727
                  }
                },
                "fileName": "csm_blick-auf-sempachersee-herbst_1_907be51842.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Sempacherschlacht war die entscheidende Schlacht im Sempacherkrieg zwischen der sich entwickelnden Eidgenossenschaft und dem Herzogtum Österreich, der von 1385 bis 1389 dauerte.",
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1elA60J5VPKasNM6VNpwJY",
              "type": "Entry",
              "createdAt": "2019-10-03T12:11:01.671Z",
              "updatedAt": "2019-10-03T12:11:01.671Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Wissen"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "7wBJJHUf6Nvt5dShbA1wM",
          "type": "Entry",
          "createdAt": "2019-10-07T18:40:27.893Z",
          "updatedAt": "2019-10-09T11:42:29.475Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "routeMode"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Bus",
          "icon": "bus.svg"
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "8pZ2nnOAvQZbmOfQjecvc",
          "type": "Entry",
          "createdAt": "2019-10-04T10:53:04.622Z",
          "updatedAt": "2019-10-10T19:52:47.807Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 6,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Marbach",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "4bokSgKssjeRALgqcxvFT",
              "type": "Asset",
              "createdAt": "2019-10-10T19:46:49.021Z",
              "updatedAt": "2019-10-10T19:46:49.021Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "wandern-entlebuch-marbachegg-kemmeriboden-bad-5-2",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/4bokSgKssjeRALgqcxvFT/f36496dbc60a5edfc6c18fc83f2f2f7e/wandern-entlebuch-marbachegg-kemmeriboden-bad-5-2.jpg",
                "details": {
                  "size": 1078182,
                  "image": {
                    "width": 1000,
                    "height": 665
                  }
                },
                "fileName": "wandern-entlebuch-marbachegg-kemmeriboden-bad-5-2.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Nimm Dir eine Auszeit und entdecke die Umgebung zu Fuss oder miete Dir ein Bike.\nURS Tip: Wanderung Trubschachen-Marbach",
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1nmTM1u3sYcb62YmZAq8Dr",
              "type": "Entry",
              "createdAt": "2019-10-04T09:46:33.431Z",
              "updatedAt": "2019-10-04T11:46:09.278Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Aktivitaet"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "HPkYRVy1vZCcgIhcK3wrd",
          "type": "Entry",
          "createdAt": "2019-10-08T09:11:34.059Z",
          "updatedAt": "2019-10-10T16:47:03.901Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 5,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r3 Interlaken- Meiringen Hasliberg",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "4E9g9yLCZh6guB69fudAqn",
                "type": "Entry",
                "createdAt": "2019-10-08T09:10:41.767Z",
                "updatedAt": "2019-10-08T09:51:28.162Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 2,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Berge",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "3mwSrRohxVlXBfmPP14nbA",
                    "type": "Asset",
                    "createdAt": "2019-10-08T09:08:49.854Z",
                    "updatedAt": "2019-10-08T09:08:49.854Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Meiringen Hasliberg",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/3mwSrRohxVlXBfmPP14nbA/57b4868c21561860d9d0cf7cc71c4926/florian-gretillat-zj_9WewVEw0-unsplash.jpg",
                      "details": {
                        "size": 2169578,
                        "image": {
                          "width": 2655,
                          "height": 3975
                        }
                      },
                      "fileName": "florian-gretillat-zj_9WewVEw0-unsplash.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Mach einen Stop in Meiringen und entdecke zu Fuss die wunderschöne Umgebung.",
                "location": {
                  "lon": 8.190908100000001,
                  "lat": 46.7251614
                },
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1nmTM1u3sYcb62YmZAq8Dr",
                    "type": "Entry",
                    "createdAt": "2019-10-04T09:46:33.431Z",
                    "updatedAt": "2019-10-04T11:46:09.278Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Aktivitaet"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "4cL0TjiGOhUEj8zs6eQQeJ",
              "type": "Entry",
              "createdAt": "2019-10-03T09:56:44.855Z",
              "updatedAt": "2019-10-09T11:42:51.303Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Fuss",
              "icon": "walk.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "2V2GckCdRiqU5JgPJK8qTD",
                "type": "Entry",
                "createdAt": "2019-10-08T09:13:14.832Z",
                "updatedAt": "2019-10-08T09:13:19.716Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 2,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Interlaken",
                "location": {
                  "lon": 7.863204900000028,
                  "lat": 46.6863481
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "3vM1IyJroYFjT8XxhZ71ge",
              "type": "Asset",
              "createdAt": "2019-10-10T11:21:05.450Z",
              "updatedAt": "2019-10-10T11:21:05.450Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "map-R3 Interlaken Meiringen",
              "description": "Zug, Fuss",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/3vM1IyJroYFjT8XxhZ71ge/21af68fe2d4e6b0dd49eb465c3e0b56c/map-R3_Interlaken_Meiringen.geojson",
                "details": {
                  "size": 5421
                },
                "fileName": "map-R3_Interlaken_Meiringen.geojson",
                "contentType": "application/octet-stream"
              }
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "UcoPo4U4h67wlhQIzVGHd",
          "type": "Entry",
          "createdAt": "2019-10-03T12:08:06.876Z",
          "updatedAt": "2019-10-08T06:45:33.038Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "attraction"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Kambly-Fabrik",
          "attractionImage": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "6Oy7aAQdCD8bKU5y84ymRy",
              "type": "Asset",
              "createdAt": "2019-10-03T12:09:00.291Z",
              "updatedAt": "2019-10-03T12:09:00.291Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "kambly-Bretzeli-Woraus Genusstraume-entstehen",
              "file": {
                "url": "//images.ctfassets.net/1es0unlkw916/6Oy7aAQdCD8bKU5y84ymRy/44a5aea976b4477ee0234d48ec216185/kambly-Bretzeli-Woraus_Genusstraume-entstehen.jpg",
                "details": {
                  "size": 85542,
                  "image": {
                    "width": 876,
                    "height": 902
                  }
                },
                "fileName": "kambly-Bretzeli-Woraus_Genusstraume-entstehen.jpg",
                "contentType": "image/jpeg"
              }
            }
          },
          "description": "Besuche die tradionsreiche Kambly-Fabrik in Trubschachen und geniesse die weltbekannten Bretzeli.",
          "location": {
            "lon": 7.849606999999992,
            "lat": 46.920368
          },
          "attractionType": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "2pJge6Pyt7hpbKhEcHunDS",
              "type": "Entry",
              "createdAt": "2019-10-03T12:07:48.634Z",
              "updatedAt": "2019-10-03T12:07:48.634Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "attractionType"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Kulinarisch"
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "amw0hn0KXVZwxY4TGcFlN",
          "type": "Entry",
          "createdAt": "2019-10-03T12:17:08.795Z",
          "updatedAt": "2019-10-10T12:46:13.002Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 7,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r2 Trubschachen",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "UcoPo4U4h67wlhQIzVGHd",
                "type": "Entry",
                "createdAt": "2019-10-03T12:08:06.876Z",
                "updatedAt": "2019-10-08T06:45:33.038Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 2,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Kambly-Fabrik",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "6Oy7aAQdCD8bKU5y84ymRy",
                    "type": "Asset",
                    "createdAt": "2019-10-03T12:09:00.291Z",
                    "updatedAt": "2019-10-03T12:09:00.291Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "kambly-Bretzeli-Woraus Genusstraume-entstehen",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/6Oy7aAQdCD8bKU5y84ymRy/44a5aea976b4477ee0234d48ec216185/kambly-Bretzeli-Woraus_Genusstraume-entstehen.jpg",
                      "details": {
                        "size": 85542,
                        "image": {
                          "width": 876,
                          "height": 902
                        }
                      },
                      "fileName": "kambly-Bretzeli-Woraus_Genusstraume-entstehen.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Besuche die tradionsreiche Kambly-Fabrik in Trubschachen und geniesse die weltbekannten Bretzeli.",
                "location": {
                  "lon": 7.849606999999992,
                  "lat": 46.920368
                },
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "2pJge6Pyt7hpbKhEcHunDS",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:07:48.634Z",
                    "updatedAt": "2019-10-03T12:07:48.634Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Kulinarisch"
                  }
                }
              }
            },
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "8pZ2nnOAvQZbmOfQjecvc",
                "type": "Entry",
                "createdAt": "2019-10-04T10:53:04.622Z",
                "updatedAt": "2019-10-10T19:52:47.807Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 6,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Marbach",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "4bokSgKssjeRALgqcxvFT",
                    "type": "Asset",
                    "createdAt": "2019-10-10T19:46:49.021Z",
                    "updatedAt": "2019-10-10T19:46:49.021Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "wandern-entlebuch-marbachegg-kemmeriboden-bad-5-2",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/4bokSgKssjeRALgqcxvFT/f36496dbc60a5edfc6c18fc83f2f2f7e/wandern-entlebuch-marbachegg-kemmeriboden-bad-5-2.jpg",
                      "details": {
                        "size": 1078182,
                        "image": {
                          "width": 1000,
                          "height": 665
                        }
                      },
                      "fileName": "wandern-entlebuch-marbachegg-kemmeriboden-bad-5-2.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Nimm Dir eine Auszeit und entdecke die Umgebung zu Fuss oder miete Dir ein Bike.\nURS Tip: Wanderung Trubschachen-Marbach",
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1nmTM1u3sYcb62YmZAq8Dr",
                    "type": "Entry",
                    "createdAt": "2019-10-04T09:46:33.431Z",
                    "updatedAt": "2019-10-04T11:46:09.278Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Aktivitaet"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "4cL0TjiGOhUEj8zs6eQQeJ",
              "type": "Entry",
              "createdAt": "2019-10-03T09:56:44.855Z",
              "updatedAt": "2019-10-09T11:42:51.303Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Fuss",
              "icon": "walk.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "28QH3BsxVaoqFqUgtUpAE9",
                "type": "Entry",
                "createdAt": "2019-10-03T12:17:00.410Z",
                "updatedAt": "2019-10-03T12:17:00.411Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Trubschachen",
                "location": {
                  "lon": 7.846130784061415,
                  "lat": 46.92169147842277
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "7968b9ubUJK55PJ0QRe0oc",
              "type": "Asset",
              "createdAt": "2019-10-09T12:25:51.066Z",
              "updatedAt": "2019-10-10T08:20:01.713Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 3,
              "locale": "en-US"
            },
            "fields": {
              "title": "map-R2 Trubschachen Grosshorben_ Kambly",
              "description": "Fuss map-R2 Trubschachen Grosshorben_Kamly",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/7968b9ubUJK55PJ0QRe0oc/0f2401d6798f8ad90b7ae5cc5f4e3c75/map-R2_Trubschachen_Grosshorb_Kambly.geojson",
                "details": {
                  "size": 3000
                },
                "fileName": "map-R2_Trubschachen_Grosshorb_Kambly.geojson",
                "contentType": "application/octet-stream"
              }
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "bIrZabISHFYreGXJcI1HW",
          "type": "Entry",
          "createdAt": "2019-10-07T21:29:44.468Z",
          "updatedAt": "2019-10-10T19:20:19.704Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 5,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r1 bern Höheweg -bern bahnhof",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "2177PADcFjrxyR9nKpRnJI",
                "type": "Entry",
                "createdAt": "2019-10-07T21:36:12.561Z",
                "updatedAt": "2019-10-07T22:11:32.596Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 5,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Aare",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "3m73fRCOLvmN1XPCSbmDPC",
                    "type": "Asset",
                    "createdAt": "2019-10-07T22:07:15.240Z",
                    "updatedAt": "2019-10-08T08:43:34.397Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Kirchfeldbrücke",
                    "description": "Kirchfeldbrücke",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/3m73fRCOLvmN1XPCSbmDPC/dbed9fd31e16920c299dd09f6f17d09b/will-truettner-aigrKLc6xc0-unsplash.jpg",
                      "details": {
                        "size": 9411132,
                        "image": {
                          "width": 4912,
                          "height": 7360
                        }
                      },
                      "fileName": "will-truettner-aigrKLc6xc0-unsplash.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Fahr über die Kirchfeldbrücke und geniess den Blick über die Aare.\nDie Kirchfeldbrücke wurde in in 21 Monaten errichtet und am 24. September 1883 eingeweiht.",
                "location": {
                  "lon": 7.448576900000035,
                  "lat": 46.9457675
                },
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1elA60J5VPKasNM6VNpwJY",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:11:01.671Z",
                    "updatedAt": "2019-10-03T12:11:01.671Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Wissen"
                  }
                }
              }
            },
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "61Xs1TfFwkh06lS4RSG3fX",
                "type": "Entry",
                "createdAt": "2019-10-07T21:44:03.829Z",
                "updatedAt": "2019-10-09T10:56:21.226Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 2,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Adrianos",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "1bM76eqaSDR9H1bl1UXAp6",
                    "type": "Asset",
                    "createdAt": "2019-10-04T10:14:55.880Z",
                    "updatedAt": "2019-10-04T10:14:55.880Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "dario-DLrRYHBydj4-unsplash",
                    "description": "Adrianos\n",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/1bM76eqaSDR9H1bl1UXAp6/14fb778d0c8afccad4faf5b8a62c0e1f/dario-DLrRYHBydj4-unsplash.jpg",
                      "details": {
                        "size": 2400378,
                        "image": {
                          "width": 3036,
                          "height": 4048
                        }
                      },
                      "fileName": "dario-DLrRYHBydj4-unsplash.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Hol dir einen Kaffe in der Adrianos Bar. Adrianos hat eine Hauseigene Rösterei in der Alten Feuerwehr Viktoria in Bern.",
                "location": {
                  "lon": 7.447254199999975,
                  "lat": 46.9478491
                },
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "2pJge6Pyt7hpbKhEcHunDS",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:07:48.634Z",
                    "updatedAt": "2019-10-03T12:07:48.634Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Kulinarisch"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "7wBJJHUf6Nvt5dShbA1wM",
              "type": "Entry",
              "createdAt": "2019-10-07T18:40:27.893Z",
              "updatedAt": "2019-10-09T11:42:29.475Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Bus",
              "icon": "bus.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "7J95WjmdU3FWzx0hwPOkJb",
                "type": "Entry",
                "createdAt": "2019-10-03T12:27:59.091Z",
                "updatedAt": "2019-10-03T12:27:59.091Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Bern, Höheweg",
                "location": {
                  "lon": 7.461626840015811,
                  "lat": 46.945792293565205
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "33gcGdVeIelynHE12vChpl",
              "type": "Asset",
              "createdAt": "2019-10-10T08:39:04.075Z",
              "updatedAt": "2019-10-10T08:41:31.120Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "locale": "en-US"
            },
            "fields": {
              "title": "map-R1 BernH BernBahnhof",
              "description": "Fuss, Buss",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/33gcGdVeIelynHE12vChpl/9ba7ace0e761a24ba65720a180c884fd/map-R1_BernH_BernBahnhof.geojson",
                "details": {
                  "size": 1414
                },
                "fileName": "map-R1_BernH_BernBahnhof.geojson",
                "contentType": "application/octet-stream"
              }
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "jCqdYOgVDoQ2EqMBLIAhQ",
          "type": "Entry",
          "createdAt": "2019-10-08T09:58:29.015Z",
          "updatedAt": "2019-10-10T09:19:12.865Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "partRoute"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "r3 Luzern Bahnhof -Werkstatt",
          "items": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "3PnRLWenv413BRoWJX2xbN",
                "type": "Entry",
                "createdAt": "2019-10-08T09:53:44.642Z",
                "updatedAt": "2019-10-08T09:53:44.642Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "attraction"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Zur Werkstatt",
                "attractionImage": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "4skLtIKCG13FwiEKyBH4BD",
                    "type": "Asset",
                    "createdAt": "2019-10-08T09:52:04.999Z",
                    "updatedAt": "2019-10-08T09:55:44.561Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 2,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Zur Werkstatt",
                    "file": {
                      "url": "//images.ctfassets.net/1es0unlkw916/4skLtIKCG13FwiEKyBH4BD/757b5614b4459e4d71b2cda6ddec04c3/jon-fu-1JFC1uPitUQ-unsplash.jpg",
                      "details": {
                        "size": 2014825,
                        "image": {
                          "width": 3862,
                          "height": 4827
                        }
                      },
                      "fileName": "jon-fu-1JFC1uPitUQ-unsplash.jpg",
                      "contentType": "image/jpeg"
                    }
                  }
                },
                "description": "Du hast dein Ziel erreicht. Bist Du hungrig? \nUrs hat noch einen insider Tip für Dich abseits der Touristenattraktionen.\n\nURS Tip: Restaurant zur Werkstadt",
                "location": {
                  "lon": 8.306336699999974,
                  "lat": 47.0458113
                },
                "attractionType": {
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "1es0unlkw916"
                      }
                    },
                    "id": "2pJge6Pyt7hpbKhEcHunDS",
                    "type": "Entry",
                    "createdAt": "2019-10-03T12:07:48.634Z",
                    "updatedAt": "2019-10-03T12:07:48.634Z",
                    "environment": {
                      "sys": {
                        "id": "master",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "attractionType"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Kulinarisch"
                  }
                }
              }
            }
          ],
          "routeMode": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "4cL0TjiGOhUEj8zs6eQQeJ",
              "type": "Entry",
              "createdAt": "2019-10-03T09:56:44.855Z",
              "updatedAt": "2019-10-09T11:42:51.303Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 2,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "routeMode"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "title": "Fuss",
              "icon": "walk.svg"
            }
          },
          "locations": [
            {
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "1es0unlkw916"
                  }
                },
                "id": "xTDNC3LU936C1gjVmvFXk",
                "type": "Entry",
                "createdAt": "2019-10-03T12:19:45.941Z",
                "updatedAt": "2019-10-03T12:19:45.941Z",
                "environment": {
                  "sys": {
                    "id": "master",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "location"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Luzern",
                "location": {
                  "lon": 8.310826200000065,
                  "lat": 47.0507934
                }
              }
            }
          ],
          "mapRoute": {
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "1es0unlkw916"
                }
              },
              "id": "1325ZsqmHfVrLGWOXGjm7U",
              "type": "Asset",
              "createdAt": "2019-10-10T09:18:55.817Z",
              "updatedAt": "2019-10-10T09:18:55.817Z",
              "environment": {
                "sys": {
                  "id": "master",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "revision": 1,
              "locale": "en-US"
            },
            "fields": {
              "title": "map-R3 Luzernb Werkstatt",
              "description": "zu Fuss",
              "file": {
                "url": "//assets.ctfassets.net/1es0unlkw916/1325ZsqmHfVrLGWOXGjm7U/c5bd2e9a2623b7814a0a247ed64bf451/map-R3_Luzernb_Werkstatt.geojson",
                "details": {
                  "size": 585
                },
                "fileName": "map-R3_Luzernb_Werkstatt.geojson",
                "contentType": "application/octet-stream"
              }
            }
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "xTDNC3LU936C1gjVmvFXk",
          "type": "Entry",
          "createdAt": "2019-10-03T12:19:45.941Z",
          "updatedAt": "2019-10-03T12:19:45.941Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "contentType": {
            "sys": {
              "type": "Link",
              "linkType": "ContentType",
              "id": "location"
            }
          },
          "locale": "en-US"
        },
        "fields": {
          "title": "Luzern",
          "location": {
            "lon": 8.310826200000065,
            "lat": 47.0507934
          }
        }
      }
    ],
    "Asset": [
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "016GYH36BqhAVd5wZVfsfG",
          "type": "Asset",
          "createdAt": "2019-10-08T08:45:26.956Z",
          "updatedAt": "2019-10-08T08:45:26.956Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "cupcakes",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/016GYH36BqhAVd5wZVfsfG/ac509e4c1cc5f30aa96f9bfd6f292b80/brian-chan-qJ0zGkrE1Zg-unsplash.jpg",
            "details": {
              "size": 1424621,
              "image": {
                "width": 4272,
                "height": 2848
              }
            },
            "fileName": "brian-chan-qJ0zGkrE1Zg-unsplash.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "1325ZsqmHfVrLGWOXGjm7U",
          "type": "Asset",
          "createdAt": "2019-10-10T09:18:55.817Z",
          "updatedAt": "2019-10-10T09:18:55.817Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "map-R3 Luzernb Werkstatt",
          "description": "zu Fuss",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/1325ZsqmHfVrLGWOXGjm7U/c5bd2e9a2623b7814a0a247ed64bf451/map-R3_Luzernb_Werkstatt.geojson",
            "details": {
              "size": 585
            },
            "fileName": "map-R3_Luzernb_Werkstatt.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "1J2EfNccGiDi7QTMcLTdXb",
          "type": "Asset",
          "createdAt": "2019-10-10T09:09:25.883Z",
          "updatedAt": "2019-10-10T09:09:25.883Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "map-R1 LuzernB Luzern Löwendenkmal",
          "description": "Fuss",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/1J2EfNccGiDi7QTMcLTdXb/fa4275fdffcaf7674ead154e37f4965d/map-R1_LuzernB_Luzern_L__wendenkmal.geojson",
            "details": {
              "size": 818
            },
            "fileName": "map-R1_LuzernB_Luzern_Löwendenkmal.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "1bM76eqaSDR9H1bl1UXAp6",
          "type": "Asset",
          "createdAt": "2019-10-04T10:14:55.880Z",
          "updatedAt": "2019-10-04T10:14:55.880Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "dario-DLrRYHBydj4-unsplash",
          "description": "Adrianos\n",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/1bM76eqaSDR9H1bl1UXAp6/14fb778d0c8afccad4faf5b8a62c0e1f/dario-DLrRYHBydj4-unsplash.jpg",
            "details": {
              "size": 2400378,
              "image": {
                "width": 3036,
                "height": 4048
              }
            },
            "fileName": "dario-DLrRYHBydj4-unsplash.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "1gOT3r97QIiGBjBx6KlwqX",
          "type": "Asset",
          "createdAt": "2019-10-08T09:56:06.932Z",
          "updatedAt": "2019-10-08T09:56:06.932Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "Hexenturm",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/1gOT3r97QIiGBjBx6KlwqX/24147c4039ccff423d9d0767df87dd45/images-10.jpeg",
            "details": {
              "size": 9063,
              "image": {
                "width": 275,
                "height": 183
              }
            },
            "fileName": "images-10.jpeg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "1uu4eZblrkiJuGeKcGnotY",
          "type": "Asset",
          "createdAt": "2019-10-10T08:28:09.513Z",
          "updatedAt": "2019-10-10T08:28:09.513Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "map-R2 LuzernBahnhof Luzern Karli",
          "description": "zu Fuss",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/1uu4eZblrkiJuGeKcGnotY/ed4abd075d309ee5081b2b2d7ce5ae90/map-R2_LuzernBahnhof_Luzern_Karli.geojson",
            "details": {
              "size": 1047
            },
            "fileName": "map-R2_LuzernBahnhof_Luzern_Karli.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "1zHnn6bNw7wCo7KtJH6nEg",
          "type": "Asset",
          "createdAt": "2019-10-03T12:08:59.978Z",
          "updatedAt": "2019-10-03T12:08:59.978Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "nicolas-jossi-sXqap3 VbWI-unsplash",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/1zHnn6bNw7wCo7KtJH6nEg/fd3fe0c80f8374b0573571a056731a0f/nicolas-jossi-sXqap3_VbWI-unsplash.jpg",
            "details": {
              "size": 463248,
              "image": {
                "width": 1653,
                "height": 2652
              }
            },
            "fileName": "nicolas-jossi-sXqap3_VbWI-unsplash.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "2DmgRgy9v6KlwP8Nu6q9E2",
          "type": "Asset",
          "createdAt": "2019-10-10T09:06:01.304Z",
          "updatedAt": "2019-10-10T09:06:01.304Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "map-R1 BernBahnhof LuzernB",
          "description": "Zug",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/2DmgRgy9v6KlwP8Nu6q9E2/b6fde7c696ff2bf465b6f5c22f322897/map-R1_BernBahnhof_LuzernB.geojson",
            "details": {
              "size": 4002
            },
            "fileName": "map-R1_BernBahnhof_LuzernB.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "2ERiPx0iyVJ4qiArie7gzj",
          "type": "Asset",
          "createdAt": "2019-10-10T11:33:29.676Z",
          "updatedAt": "2019-10-10T11:33:29.676Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "map-R3 Meiringen LuzernBahnhof",
          "description": "Zug, Fuss",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/2ERiPx0iyVJ4qiArie7gzj/8e691aabc6270d48139ddb6b2c6d3535/map-R3__Meiringen_LuzernBahnhof.geojson",
            "details": {
              "size": 4370
            },
            "fileName": "map-R3_ Meiringen_LuzernBahnhof.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "30hHywqltv5XhCokIhn5HC",
          "type": "Asset",
          "createdAt": "2019-10-09T12:40:28.571Z",
          "updatedAt": "2019-10-09T12:40:28.571Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "map-R2 Trubschachen Luzern",
          "description": "Zug map-R2 Trubschachen Luzern",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/30hHywqltv5XhCokIhn5HC/04b2e9a80f09e8e9f38139971e048636/map-R2_Trubschachen_Luzern.geojson",
            "details": {
              "size": 3379
            },
            "fileName": "map-R2_Trubschachen_Luzern.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "33gcGdVeIelynHE12vChpl",
          "type": "Asset",
          "createdAt": "2019-10-10T08:39:04.075Z",
          "updatedAt": "2019-10-10T08:41:31.120Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "locale": "en-US"
        },
        "fields": {
          "title": "map-R1 BernH BernBahnhof",
          "description": "Fuss, Buss",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/33gcGdVeIelynHE12vChpl/9ba7ace0e761a24ba65720a180c884fd/map-R1_BernH_BernBahnhof.geojson",
            "details": {
              "size": 1414
            },
            "fileName": "map-R1_BernH_BernBahnhof.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "3E3OG3GA4BLQAosOQcTsx4",
          "type": "Asset",
          "createdAt": "2019-10-04T10:15:26.162Z",
          "updatedAt": "2019-10-04T10:15:26.162Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "portrait-home",
          "description": "Zofingen",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/3E3OG3GA4BLQAosOQcTsx4/9f835a72234cbdcefaf121e0f59d343c/portrait-home.jpg",
            "details": {
              "size": 130144,
              "image": {
                "width": 1050,
                "height": 699
              }
            },
            "fileName": "portrait-home.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "3dlX4Gk7LiWLUzBlfWbt12",
          "type": "Asset",
          "createdAt": "2019-10-03T12:08:59.982Z",
          "updatedAt": "2019-10-03T12:08:59.982Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "manuel-boxler-BbwYJ36B2aw-unsplash",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/3dlX4Gk7LiWLUzBlfWbt12/2ca683b9c7aadd689d7b702db054af1b/manuel-boxler-BbwYJ36B2aw-unsplash.jpg",
            "details": {
              "size": 2767493,
              "image": {
                "width": 5464,
                "height": 3070
              }
            },
            "fileName": "manuel-boxler-BbwYJ36B2aw-unsplash.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "3m73fRCOLvmN1XPCSbmDPC",
          "type": "Asset",
          "createdAt": "2019-10-07T22:07:15.240Z",
          "updatedAt": "2019-10-08T08:43:34.397Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "locale": "en-US"
        },
        "fields": {
          "title": "Kirchfeldbrücke",
          "description": "Kirchfeldbrücke",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/3m73fRCOLvmN1XPCSbmDPC/dbed9fd31e16920c299dd09f6f17d09b/will-truettner-aigrKLc6xc0-unsplash.jpg",
            "details": {
              "size": 9411132,
              "image": {
                "width": 4912,
                "height": 7360
              }
            },
            "fileName": "will-truettner-aigrKLc6xc0-unsplash.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "3mwSrRohxVlXBfmPP14nbA",
          "type": "Asset",
          "createdAt": "2019-10-08T09:08:49.854Z",
          "updatedAt": "2019-10-08T09:08:49.854Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "Meiringen Hasliberg",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/3mwSrRohxVlXBfmPP14nbA/57b4868c21561860d9d0cf7cc71c4926/florian-gretillat-zj_9WewVEw0-unsplash.jpg",
            "details": {
              "size": 2169578,
              "image": {
                "width": 2655,
                "height": 3975
              }
            },
            "fileName": "florian-gretillat-zj_9WewVEw0-unsplash.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "3pl039XsQzKaszISrEwNu4",
          "type": "Asset",
          "createdAt": "2019-10-10T15:44:38.104Z",
          "updatedAt": "2019-10-10T15:44:38.104Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "Marker violet",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/3pl039XsQzKaszISrEwNu4/8c3a6de3c081095a18251bbd1cd9312f/Marker_violet.svg",
            "details": {
              "size": 836,
              "image": {
                "width": 24,
                "height": 23
              }
            },
            "fileName": "Marker_violet.svg",
            "contentType": "image/svg+xml"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "3vM1IyJroYFjT8XxhZ71ge",
          "type": "Asset",
          "createdAt": "2019-10-10T11:21:05.450Z",
          "updatedAt": "2019-10-10T11:21:05.450Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "map-R3 Interlaken Meiringen",
          "description": "Zug, Fuss",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/3vM1IyJroYFjT8XxhZ71ge/21af68fe2d4e6b0dd49eb465c3e0b56c/map-R3_Interlaken_Meiringen.geojson",
            "details": {
              "size": 5421
            },
            "fileName": "map-R3_Interlaken_Meiringen.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "48sDwwqaq8yzHhapdigeXx",
          "type": "Asset",
          "createdAt": "2019-10-08T08:44:36.667Z",
          "updatedAt": "2019-10-08T08:44:36.667Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "Thunersee",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/48sDwwqaq8yzHhapdigeXx/8bd55a0dbe170707c34594ef4649ac1e/prakarsh-saxena-k4AoLA76NRc-unsplash.jpg",
            "details": {
              "size": 3299553,
              "image": {
                "width": 5184,
                "height": 2920
              }
            },
            "fileName": "prakarsh-saxena-k4AoLA76NRc-unsplash.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "4EbL6vJFcER68gikHWucyV",
          "type": "Asset",
          "createdAt": "2019-10-08T08:45:58.643Z",
          "updatedAt": "2019-10-08T08:45:58.643Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "Brücken",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/4EbL6vJFcER68gikHWucyV/bb0e96f86d48bb1f414fec5a59f04154/alain-GIWvrROAZE0-unsplash.jpg",
            "details": {
              "size": 3757313,
              "image": {
                "width": 4000,
                "height": 6000
              }
            },
            "fileName": "alain-GIWvrROAZE0-unsplash.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "4bokSgKssjeRALgqcxvFT",
          "type": "Asset",
          "createdAt": "2019-10-10T19:46:49.021Z",
          "updatedAt": "2019-10-10T19:46:49.021Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "wandern-entlebuch-marbachegg-kemmeriboden-bad-5-2",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/4bokSgKssjeRALgqcxvFT/f36496dbc60a5edfc6c18fc83f2f2f7e/wandern-entlebuch-marbachegg-kemmeriboden-bad-5-2.jpg",
            "details": {
              "size": 1078182,
              "image": {
                "width": 1000,
                "height": 665
              }
            },
            "fileName": "wandern-entlebuch-marbachegg-kemmeriboden-bad-5-2.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "4skLtIKCG13FwiEKyBH4BD",
          "type": "Asset",
          "createdAt": "2019-10-08T09:52:04.999Z",
          "updatedAt": "2019-10-08T09:55:44.561Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "locale": "en-US"
        },
        "fields": {
          "title": "Zur Werkstatt",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/4skLtIKCG13FwiEKyBH4BD/757b5614b4459e4d71b2cda6ddec04c3/jon-fu-1JFC1uPitUQ-unsplash.jpg",
            "details": {
              "size": 2014825,
              "image": {
                "width": 3862,
                "height": 4827
              }
            },
            "fileName": "jon-fu-1JFC1uPitUQ-unsplash.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "4yM5WoNgaczWkAkgtnSdFu",
          "type": "Asset",
          "createdAt": "2019-10-04T10:13:47.853Z",
          "updatedAt": "2019-10-04T10:14:22.956Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "locale": "en-US"
        },
        "fields": {
          "title": "csm_blick-auf-sempachersee-herbst_1_907be51842",
          "description": "Sepachersee\n",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/4yM5WoNgaczWkAkgtnSdFu/035eb626d3a5678657f8da1a213a053e/csm_blick-auf-sempachersee-herbst_1_907be51842.jpg",
            "details": {
              "size": 234969,
              "image": {
                "width": 1280,
                "height": 727
              }
            },
            "fileName": "csm_blick-auf-sempachersee-herbst_1_907be51842.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "563qkH6ApetL6DRMvd5GJh",
          "type": "Asset",
          "createdAt": "2019-10-03T12:09:00.054Z",
          "updatedAt": "2019-10-03T12:09:00.054Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "gang-delicious-5192364-2",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/563qkH6ApetL6DRMvd5GJh/edd38bbdcda22a47679e25789cdb7eb5/gang-delicious-5192364-2.jpg",
            "details": {
              "size": 130914,
              "image": {
                "width": 821,
                "height": 850
              }
            },
            "fileName": "gang-delicious-5192364-2.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "5F29eu8dZ1jpAYOlQXx8Ej",
          "type": "Asset",
          "createdAt": "2019-10-03T12:09:00.317Z",
          "updatedAt": "2019-10-03T12:09:00.317Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "jovana-askrabic-vEBsRMCis-c-unsplash",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/5F29eu8dZ1jpAYOlQXx8Ej/ad82f0380ff9a2745cfef2e2e9039066/jovana-askrabic-vEBsRMCis-c-unsplash.jpg",
            "details": {
              "size": 2182061,
              "image": {
                "width": 4534,
                "height": 3023
              }
            },
            "fileName": "jovana-askrabic-vEBsRMCis-c-unsplash.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "5Ig7KvBKBY5O8MSwR0c3yw",
          "type": "Asset",
          "createdAt": "2019-10-03T12:09:00.127Z",
          "updatedAt": "2019-10-03T12:09:00.127Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "csm 01 AEnziloch 01 Typo3 698cb5cacc",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/5Ig7KvBKBY5O8MSwR0c3yw/7f0ce3680c5bf790f4d6421fb306a866/csm_01_AEnziloch_01_Typo3_698cb5cacc.jpg",
            "details": {
              "size": 241259,
              "image": {
                "width": 1280,
                "height": 727
              }
            },
            "fileName": "csm_01_AEnziloch_01_Typo3_698cb5cacc.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "5QKaYQcbvydEGqWgaVy6Se",
          "type": "Asset",
          "createdAt": "2019-10-10T15:38:40.029Z",
          "updatedAt": "2019-10-10T15:43:30.982Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 2,
          "locale": "en-US"
        },
        "fields": {
          "title": "Marker mint",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/5QKaYQcbvydEGqWgaVy6Se/e8d41ef74ab9bc98ff3af2d49984cbf4/Marker_mint.svg",
            "details": {
              "size": 836,
              "image": {
                "width": 24,
                "height": 23
              }
            },
            "fileName": "Marker_mint.svg",
            "contentType": "image/svg+xml"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "5RxlYgOahrEEEYIDoUBaBR",
          "type": "Asset",
          "createdAt": "2019-10-03T12:09:00.290Z",
          "updatedAt": "2019-10-03T12:09:00.290Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "emmental-ausflugstipps-chechlihus-langnau",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/5RxlYgOahrEEEYIDoUBaBR/28ae1cf5dc3f9f66bc11dff62e08718c/emmental-ausflugstipps-chechlihus-langnau.jpg",
            "details": {
              "size": 401110,
              "image": {
                "width": 1920,
                "height": 1281
              }
            },
            "fileName": "emmental-ausflugstipps-chechlihus-langnau.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "5q00Mod2WjBFXrYXFZ0osC",
          "type": "Asset",
          "createdAt": "2019-10-09T11:46:01.424Z",
          "updatedAt": "2019-10-09T11:53:01.341Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 3,
          "locale": "en-US"
        },
        "fields": {
          "title": "R2 BernBahnhof- Langnau i. E.",
          "description": "R2 Bahn BernBahnhof- Langnau i. E.",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/5q00Mod2WjBFXrYXFZ0osC/c182af188a035a920969b8e552198440/map-R2._BernB_Langnau.geojson",
            "details": {
              "size": 1291
            },
            "fileName": "map-R2._BernB_Langnau.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "66a0prYBagbqkTccJiQ7IM",
          "type": "Asset",
          "createdAt": "2019-10-10T11:04:56.800Z",
          "updatedAt": "2019-10-10T11:04:56.800Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "map-R3 Bernbahnhof Interlaken",
          "description": "Zug",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/66a0prYBagbqkTccJiQ7IM/466813b0dc36538279b057609fbf4e73/map-R3_Bernbahnhof_Interlaken.geojson",
            "details": {
              "size": 3290
            },
            "fileName": "map-R3_Bernbahnhof_Interlaken.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "6Oy7aAQdCD8bKU5y84ymRy",
          "type": "Asset",
          "createdAt": "2019-10-03T12:09:00.291Z",
          "updatedAt": "2019-10-03T12:09:00.291Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "kambly-Bretzeli-Woraus Genusstraume-entstehen",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/6Oy7aAQdCD8bKU5y84ymRy/44a5aea976b4477ee0234d48ec216185/kambly-Bretzeli-Woraus_Genusstraume-entstehen.jpg",
            "details": {
              "size": 85542,
              "image": {
                "width": 876,
                "height": 902
              }
            },
            "fileName": "kambly-Bretzeli-Woraus_Genusstraume-entstehen.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "6QALBCBvSf44Pcmml6riMg",
          "type": "Asset",
          "createdAt": "2019-10-10T14:15:27.675Z",
          "updatedAt": "2019-10-10T14:15:27.675Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "marker_orange",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/6QALBCBvSf44Pcmml6riMg/9af2533c8a023969e8269d1a5d600f18/Marker_orange.svg",
            "details": {
              "size": 946432,
              "image": {
                "width": 24,
                "height": 23
              }
            },
            "fileName": "Marker_orange.svg",
            "contentType": "image/svg+xml"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "7043J1sN0xlS2jSVtJ1Lgd",
          "type": "Asset",
          "createdAt": "2019-10-11T08:27:00.397Z",
          "updatedAt": "2019-10-11T08:27:00.397Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "Brünigpass",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/7043J1sN0xlS2jSVtJ1Lgd/7cf7c820b77f58f6e364b6909d57c8c6/9036620-Brienz.jpg",
            "details": {
              "size": 1116737,
              "image": {
                "width": 2454,
                "height": 1381
              }
            },
            "fileName": "9036620-Brienz.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "7968b9ubUJK55PJ0QRe0oc",
          "type": "Asset",
          "createdAt": "2019-10-09T12:25:51.066Z",
          "updatedAt": "2019-10-10T08:20:01.713Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 3,
          "locale": "en-US"
        },
        "fields": {
          "title": "map-R2 Trubschachen Grosshorben_ Kambly",
          "description": "Fuss map-R2 Trubschachen Grosshorben_Kamly",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/7968b9ubUJK55PJ0QRe0oc/0f2401d6798f8ad90b7ae5cc5f4e3c75/map-R2_Trubschachen_Grosshorb_Kambly.geojson",
            "details": {
              "size": 3000
            },
            "fileName": "map-R2_Trubschachen_Grosshorb_Kambly.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "79lgsi0p4GonIr1z8XphVX",
          "type": "Asset",
          "createdAt": "2019-10-10T10:52:24.466Z",
          "updatedAt": "2019-10-10T10:52:24.466Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "map-R3 BernH Bernbahnof",
          "description": "Velo",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/79lgsi0p4GonIr1z8XphVX/5dee0440ac5ef38c925f745be8ef2038/map-R3_BernH_Bernbahnof.geojson",
            "details": {
              "size": 1700
            },
            "fileName": "map-R3 BernH_Bernbahnof.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "Ffe1iaLvziHO989F4srti",
          "type": "Asset",
          "createdAt": "2019-10-04T11:16:00.939Z",
          "updatedAt": "2019-10-04T11:16:00.939Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "kreuz herzogenbuchsee herzogenbuchsee 3360 herzogenbuchsee kreuz01 aussen",
          "description": "Herzogenbuchsee",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/Ffe1iaLvziHO989F4srti/9f742b7982d0423a8897cf3daab86bee/kreuz_herzogenbuchsee_herzogenbuchsee_3360_herzogenbuchsee_kreuz01_aussen.jpg",
            "details": {
              "size": 4369954,
              "image": {
                "width": 3573,
                "height": 2385
              }
            },
            "fileName": "kreuz_herzogenbuchsee_herzogenbuchsee_3360_herzogenbuchsee_kreuz01_aussen.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "H5iujXNQQGhnCKIxjq2Js",
          "type": "Asset",
          "createdAt": "2019-10-02T11:59:49.622Z",
          "updatedAt": "2019-10-02T11:59:49.622Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "Thun",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/H5iujXNQQGhnCKIxjq2Js/70f932f30e16ccdf5783f1c0c1e4f309/IMG_1785-HDR-WRT-Lergier.jpg",
            "details": {
              "size": 11642879,
              "image": {
                "width": 5425,
                "height": 3617
              }
            },
            "fileName": "IMG_1785-HDR-WRT-Lergier.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "OPgKCSagFCgKkfxdcRZxj",
          "type": "Asset",
          "createdAt": "2019-10-09T12:03:48.461Z",
          "updatedAt": "2019-10-09T12:03:48.461Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "map-R2 Langnau Trubschachen",
          "description": "Bahn-R2 Langnau Trubschachen",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/OPgKCSagFCgKkfxdcRZxj/66006f7d28f63f77ab5536a8f9e724cb/map-R2_Langnau_Trubschachen.geojson",
            "details": {
              "size": 671
            },
            "fileName": "map-R2_Langnau_Trubschachen.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "oo8t5jtq8K0nO9NlSkCSu",
          "type": "Asset",
          "createdAt": "2019-10-09T11:28:59.985Z",
          "updatedAt": "2019-10-10T07:58:20.985Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 3,
          "locale": "en-US"
        },
        "fields": {
          "title": "map-R2 BernHöhneweg BernBahnhof",
          "description": " BernHöhneweg BernBahnhof Velo",
          "file": {
            "url": "//assets.ctfassets.net/1es0unlkw916/oo8t5jtq8K0nO9NlSkCSu/ff25ff3d8c62b54996325888861e458b/map-R2_BernH_BernBahnhof.geojson",
            "details": {
              "size": 1070
            },
            "fileName": "map-R2_BernH_BernBahnhof.geojson",
            "contentType": "application/octet-stream"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "uzICxJFPsW4nGLirF9qIX",
          "type": "Asset",
          "createdAt": "2019-10-04T10:12:13.110Z",
          "updatedAt": "2019-10-04T10:12:13.110Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "trub-schnstes-dorf-im-emmental",
          "description": "Trub-Trubschachen\n",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/uzICxJFPsW4nGLirF9qIX/2b6ca56d1b1e113ecea2b128419521f6/trub-schnstes-dorf-im-emmental.jpg",
            "details": {
              "size": 655569,
              "image": {
                "width": 1920,
                "height": 1281
              }
            },
            "fileName": "trub-schnstes-dorf-im-emmental.jpg",
            "contentType": "image/jpeg"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "1es0unlkw916"
            }
          },
          "id": "wKSVz3kp8Xnub8B3Z62CI",
          "type": "Asset",
          "createdAt": "2019-10-08T08:44:06.701Z",
          "updatedAt": "2019-10-08T08:44:06.701Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "Gelateria",
          "file": {
            "url": "//images.ctfassets.net/1es0unlkw916/wKSVz3kp8Xnub8B3Z62CI/ea791f4ad74b5b686d4130cdea3bc2d2/csm_Luzern_Listicals_Glace_IMG_7133-Bearbeitet_Typo3_c2ff9376d8.jpg",
            "details": {
              "size": 77583,
              "image": {
                "width": 1280,
                "height": 727
              }
            },
            "fileName": "csm_Luzern_Listicals_Glace_IMG_7133-Bearbeitet_Typo3_c2ff9376d8.jpg",
            "contentType": "image/jpeg"
          }
        }
      }
    ]
  }
};
